// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/agent.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { ServiceMetadata, ServiceSpec } from "./environment_automation_pb";
import { file_gitpod_v1_environment_automation } from "./environment_automation_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/agent.proto.
 */
export const file_gitpod_v1_agent: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_environment_automation, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_google_protobuf_timestamp]);

/**
 * PullRequest represents pull request metadata from source control systems.
 * This message is used across workflow triggers, executions, and agent contexts
 * to maintain consistent PR information throughout the system.
 *
 * @generated from message gitpod.v1.PullRequest
 */
export type PullRequest = Message<"gitpod.v1.PullRequest"> & {
  /**
   * Unique identifier from the source system (e.g., "123" for GitHub PR #123)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Pull request title
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * Source branch name (the branch being merged from)
   *
   * @generated from field: string from_branch = 3;
   */
  fromBranch: string;

  /**
   * Target branch name (the branch being merged into)
   *
   * @generated from field: string to_branch = 4;
   */
  toBranch: string;

  /**
   * Pull request URL (e.g., "https://github.com/owner/repo/pull/123")
   *
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * Author name as provided by the SCM system
   *
   * @generated from field: string author = 6;
   */
  author: string;

  /**
   * @generated from field: gitpod.v1.PullRequest.Repository repository = 7;
   */
  repository?: PullRequest_Repository;

  /**
   * Whether this is a draft pull request
   *
   * @generated from field: bool draft = 8;
   */
  draft: boolean;

  /**
   * @generated from field: gitpod.v1.PullRequest.State state = 9;
   */
  state: PullRequest_State;
};

/**
 * Describes the message gitpod.v1.PullRequest.
 * Use `create(PullRequestSchema)` to create a new message.
 */
export const PullRequestSchema: GenMessage<PullRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 0);

/**
 * Repository information
 *
 * @generated from message gitpod.v1.PullRequest.Repository
 */
export type PullRequest_Repository = Message<"gitpod.v1.PullRequest.Repository"> & {
  /**
   * @generated from field: string clone_url = 1;
   */
  cloneUrl: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * @generated from field: string owner = 3;
   */
  owner: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;
};

/**
 * Describes the message gitpod.v1.PullRequest.Repository.
 * Use `create(PullRequest_RepositorySchema)` to create a new message.
 */
export const PullRequest_RepositorySchema: GenMessage<PullRequest_Repository> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 0, 0);

/**
 * Current state of the pull request
 *
 * @generated from enum gitpod.v1.PullRequest.State
 */
export enum PullRequest_State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: STATE_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * @generated from enum value: STATE_MERGED = 3;
   */
  MERGED = 3,
}

/**
 * Describes the enum gitpod.v1.PullRequest.State.
 */
export const PullRequest_StateSchema: GenEnum<PullRequest_State> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 0, 0);

/**
 * @generated from message gitpod.v1.Agent
 */
export type Agent = Message<"gitpod.v1.Agent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.AgentMetadata metadata = 2;
   */
  metadata?: AgentMetadata;

  /**
   * @generated from field: gitpod.v1.RunnerSideAgentSpec spec = 3 [deprecated = true];
   * @deprecated
   */
  spec?: RunnerSideAgentSpec;

  /**
   * @generated from oneof gitpod.v1.Agent.agent_spec
   */
  agentSpec: {
    /**
     * @generated from field: gitpod.v1.RunnerSideAgentSpec runner_side = 4;
     */
    value: RunnerSideAgentSpec;
    case: "runnerSide";
  } | {
    /**
     * @generated from field: gitpod.v1.InEnvironmentAgentSpec in_environment = 5;
     */
    value: InEnvironmentAgentSpec;
    case: "inEnvironment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 1);

/**
 * @generated from message gitpod.v1.AgentMetadata
 */
export type AgentMetadata = Message<"gitpod.v1.AgentMetadata"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message gitpod.v1.AgentMetadata.
 * Use `create(AgentMetadataSchema)` to create a new message.
 */
export const AgentMetadataSchema: GenMessage<AgentMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 2);

/**
 * @generated from message gitpod.v1.ListAgentsRequest
 */
export type ListAgentsRequest = Message<"gitpod.v1.ListAgentsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListAgentsRequest.
 * Use `create(ListAgentsRequestSchema)` to create a new message.
 */
export const ListAgentsRequestSchema: GenMessage<ListAgentsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 3);

/**
 * @generated from message gitpod.v1.ListAgentsResponse
 */
export type ListAgentsResponse = Message<"gitpod.v1.ListAgentsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Agent agents = 2;
   */
  agents: Agent[];
};

/**
 * Describes the message gitpod.v1.ListAgentsResponse.
 * Use `create(ListAgentsResponseSchema)` to create a new message.
 */
export const ListAgentsResponseSchema: GenMessage<ListAgentsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 4);

/**
 * @generated from message gitpod.v1.GetAgentRequest
 */
export type GetAgentRequest = Message<"gitpod.v1.GetAgentRequest"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;
};

/**
 * Describes the message gitpod.v1.GetAgentRequest.
 * Use `create(GetAgentRequestSchema)` to create a new message.
 */
export const GetAgentRequestSchema: GenMessage<GetAgentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 5);

/**
 * @generated from message gitpod.v1.GetAgentResponse
 */
export type GetAgentResponse = Message<"gitpod.v1.GetAgentResponse"> & {
  /**
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message gitpod.v1.GetAgentResponse.
 * Use `create(GetAgentResponseSchema)` to create a new message.
 */
export const GetAgentResponseSchema: GenMessage<GetAgentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 6);

/**
 * @generated from message gitpod.v1.AgentCodeContext
 */
export type AgentCodeContext = Message<"gitpod.v1.AgentCodeContext"> & {
  /**
   * @generated from oneof gitpod.v1.AgentCodeContext.context
   */
  context: {
    /**
     * @generated from field: string project_id = 1;
     */
    value: string;
    case: "projectId";
  } | {
    /**
     * @generated from field: string environment_id = 2;
     */
    value: string;
    case: "environmentId";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentCodeContext.ContextURL context_url = 3;
     */
    value: AgentCodeContext_ContextURL;
    case: "contextUrl";
  } | { case: undefined; value?: undefined };

  /**
   * Pull request context - optional metadata about the PR being worked on
   * This is populated when the agent execution is triggered by a PR workflow
   * or when explicitly provided through the browser extension
   *
   * @generated from field: optional gitpod.v1.PullRequest pull_request = 4;
   */
  pullRequest?: PullRequest;
};

/**
 * Describes the message gitpod.v1.AgentCodeContext.
 * Use `create(AgentCodeContextSchema)` to create a new message.
 */
export const AgentCodeContextSchema: GenMessage<AgentCodeContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 7);

/**
 * @generated from message gitpod.v1.AgentCodeContext.ContextURL
 */
export type AgentCodeContext_ContextURL = Message<"gitpod.v1.AgentCodeContext.ContextURL"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string environment_class_id = 2;
   */
  environmentClassId: string;
};

/**
 * Describes the message gitpod.v1.AgentCodeContext.ContextURL.
 * Use `create(AgentCodeContext_ContextURLSchema)` to create a new message.
 */
export const AgentCodeContext_ContextURLSchema: GenMessage<AgentCodeContext_ContextURL> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 7, 0);

/**
 * @generated from message gitpod.v1.StartAgentRequest
 */
export type StartAgentRequest = Message<"gitpod.v1.StartAgentRequest"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: gitpod.v1.AgentCodeContext code_context = 2;
   */
  codeContext?: AgentCodeContext;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * workflow_action_id is an optional reference to the workflow execution action
   * that created this agent execution. Used for tracking and event correlation.
   *
   * @generated from field: optional string workflow_action_id = 4;
   */
  workflowActionId?: string;

  /**
   * mode specifies the operational mode for this agent execution
   * If not specified, defaults to AGENT_MODE_EXECUTION
   *
   * @generated from field: gitpod.v1.AgentMode mode = 5;
   */
  mode: AgentMode;

  /**
   * runner_id specifies a runner for this agent execution.
   * When set, the agent execution is routed to this runner instead of the
   * runner associated with the environment.
   *
   * @generated from field: string runner_id = 6;
   */
  runnerId: string;

  /**
   * annotations are key-value pairs for tracking external context
   * (e.g., integration session IDs, GitHub issue references).
   * Keys should follow domain/name convention (e.g., "agent-client-session/id").
   *
   * @generated from field: map<string, string> annotations = 7;
   */
  annotations: { [key: string]: string };

  /**
   * session_id is the ID of the session this agent execution belongs to.
   * If empty, a new session is created implicitly.
   *
   * @generated from field: string session_id = 8;
   */
  sessionId: string;
};

/**
 * Describes the message gitpod.v1.StartAgentRequest.
 * Use `create(StartAgentRequestSchema)` to create a new message.
 */
export const StartAgentRequestSchema: GenMessage<StartAgentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 8);

/**
 * @generated from message gitpod.v1.StartAgentResponse
 */
export type StartAgentResponse = Message<"gitpod.v1.StartAgentResponse"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.StartAgentResponse.
 * Use `create(StartAgentResponseSchema)` to create a new message.
 */
export const StartAgentResponseSchema: GenMessage<StartAgentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 9);

/**
 * @generated from message gitpod.v1.ListAgentExecutionsRequest
 */
export type ListAgentExecutionsRequest = Message<"gitpod.v1.ListAgentExecutionsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListAgentExecutionsRequest.Filter filter = 2;
   */
  filter?: ListAgentExecutionsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListAgentExecutionsRequest.
 * Use `create(ListAgentExecutionsRequestSchema)` to create a new message.
 */
export const ListAgentExecutionsRequestSchema: GenMessage<ListAgentExecutionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 10);

/**
 * @generated from message gitpod.v1.ListAgentExecutionsRequest.Filter
 */
export type ListAgentExecutionsRequest_Filter = Message<"gitpod.v1.ListAgentExecutionsRequest.Filter"> & {
  /**
   * @generated from field: repeated string agent_ids = 1;
   */
  agentIds: string[];

  /**
   * @generated from field: repeated string project_ids = 2;
   */
  projectIds: string[];

  /**
   * @generated from field: repeated string environment_ids = 3;
   */
  environmentIds: string[];

  /**
   * @generated from field: repeated string creator_ids = 4;
   */
  creatorIds: string[];

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Phase status_phases = 5;
   */
  statusPhases: AgentExecution_Phase[];

  /**
   * @generated from field: repeated gitpod.v1.AgentExecutionRole roles = 6;
   */
  roles: AgentExecutionRole[];

  /**
   * annotations filters by key-value pairs. Only executions containing
   * all specified annotations (with matching values) are returned.
   *
   * @generated from field: map<string, string> annotations = 7;
   */
  annotations: { [key: string]: string };

  /**
   * session_ids filters the response to only executions belonging to the specified sessions
   *
   * @generated from field: repeated string session_ids = 8;
   */
  sessionIds: string[];
};

/**
 * Describes the message gitpod.v1.ListAgentExecutionsRequest.Filter.
 * Use `create(ListAgentExecutionsRequest_FilterSchema)` to create a new message.
 */
export const ListAgentExecutionsRequest_FilterSchema: GenMessage<ListAgentExecutionsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 10, 0);

/**
 * @generated from message gitpod.v1.ListAgentExecutionsResponse
 */
export type ListAgentExecutionsResponse = Message<"gitpod.v1.ListAgentExecutionsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution agent_executions = 2;
   */
  agentExecutions: AgentExecution[];
};

/**
 * Describes the message gitpod.v1.ListAgentExecutionsResponse.
 * Use `create(ListAgentExecutionsResponseSchema)` to create a new message.
 */
export const ListAgentExecutionsResponseSchema: GenMessage<ListAgentExecutionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 11);

/**
 * @generated from message gitpod.v1.GetAgentExecutionRequest
 */
export type GetAgentExecutionRequest = Message<"gitpod.v1.GetAgentExecutionRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.GetAgentExecutionRequest.
 * Use `create(GetAgentExecutionRequestSchema)` to create a new message.
 */
export const GetAgentExecutionRequestSchema: GenMessage<GetAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 12);

/**
 * @generated from message gitpod.v1.GetAgentExecutionResponse
 */
export type GetAgentExecutionResponse = Message<"gitpod.v1.GetAgentExecutionResponse"> & {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;
};

/**
 * Describes the message gitpod.v1.GetAgentExecutionResponse.
 * Use `create(GetAgentExecutionResponseSchema)` to create a new message.
 */
export const GetAgentExecutionResponseSchema: GenMessage<GetAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 13);

/**
 * @generated from message gitpod.v1.DeleteAgentExecutionRequest
 */
export type DeleteAgentExecutionRequest = Message<"gitpod.v1.DeleteAgentExecutionRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.DeleteAgentExecutionRequest.
 * Use `create(DeleteAgentExecutionRequestSchema)` to create a new message.
 */
export const DeleteAgentExecutionRequestSchema: GenMessage<DeleteAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 14);

/**
 * @generated from message gitpod.v1.DeleteAgentExecutionResponse
 */
export type DeleteAgentExecutionResponse = Message<"gitpod.v1.DeleteAgentExecutionResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteAgentExecutionResponse.
 * Use `create(DeleteAgentExecutionResponseSchema)` to create a new message.
 */
export const DeleteAgentExecutionResponseSchema: GenMessage<DeleteAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 15);

/**
 * @generated from message gitpod.v1.AgentExecution
 */
export type AgentExecution = Message<"gitpod.v1.AgentExecution"> & {
  /**
   * ID is a unique identifier of this agent run. No other agent run with the
   * same name must be managed by this agent manager
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Metadata is data associated with this agent that's required for other
   * parts of Gitpod to function
   *
   * @generated from field: gitpod.v1.AgentExecution.Metadata metadata = 2;
   */
  metadata?: AgentExecution_Metadata;

  /**
   * Spec is the configuration of the agent that's required for the
   * runner to start the agent
   *
   * @generated from field: gitpod.v1.AgentExecution.Spec spec = 3;
   */
  spec?: AgentExecution_Spec;

  /**
   * Status is the current status of the agent
   *
   * @generated from field: gitpod.v1.AgentExecution.Status status = 4;
   */
  status?: AgentExecution_Status;
};

/**
 * Describes the message gitpod.v1.AgentExecution.
 * Use `create(AgentExecutionSchema)` to create a new message.
 */
export const AgentExecutionSchema: GenMessage<AgentExecution> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16);

/**
 * @generated from message gitpod.v1.AgentExecution.Metadata
 */
export type AgentExecution_Metadata = Message<"gitpod.v1.AgentExecution.Metadata"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: gitpod.v1.Subject creator = 3;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * role is the role of the agent execution
   *
   * @generated from field: gitpod.v1.AgentExecutionRole role = 6;
   */
  role: AgentExecutionRole;

  /**
   * workflow_action_id is set when this agent execution was created as part of a workflow.
   * Used to correlate agent executions with their parent workflow execution action.
   *
   * @generated from field: optional string workflow_action_id = 7;
   */
  workflowActionId?: string;

  /**
   * annotations are key-value pairs for tracking external context.
   *
   * @generated from field: map<string, string> annotations = 8;
   */
  annotations: { [key: string]: string };

  /**
   * session_id is the ID of the session this agent execution belongs to.
   *
   * @generated from field: string session_id = 9;
   */
  sessionId: string;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Metadata.
 * Use `create(AgentExecution_MetadataSchema)` to create a new message.
 */
export const AgentExecution_MetadataSchema: GenMessage<AgentExecution_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 0);

/**
 * @generated from message gitpod.v1.AgentExecution.Spec
 */
export type AgentExecution_Spec = Message<"gitpod.v1.AgentExecution.Spec"> & {
  /**
   * version of the spec. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.spec_version <
   * b.spec_version then a was the spec before b.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion: bigint;

  /**
   * @generated from field: string session = 2;
   */
  session: string;

  /**
   * desired_phase is the desired phase of the agent run
   *
   * @generated from field: gitpod.v1.AgentExecution.Phase desired_phase = 3;
   */
  desiredPhase: AgentExecution_Phase;

  /**
   * @generated from field: string agent_id = 4;
   */
  agentId: string;

  /**
   * @generated from field: gitpod.v1.AgentCodeContext code_context = 5;
   */
  codeContext?: AgentCodeContext;

  /**
   * @generated from field: gitpod.v1.AgentExecution.Spec.Limits limits = 6;
   */
  limits?: AgentExecution_Spec_Limits;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Spec.LoopCondition loop_conditions = 8;
   */
  loopConditions: AgentExecution_Spec_LoopCondition[];
};

/**
 * Describes the message gitpod.v1.AgentExecution.Spec.
 * Use `create(AgentExecution_SpecSchema)` to create a new message.
 */
export const AgentExecution_SpecSchema: GenMessage<AgentExecution_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 1);

/**
 * @generated from message gitpod.v1.AgentExecution.Spec.Limits
 */
export type AgentExecution_Spec_Limits = Message<"gitpod.v1.AgentExecution.Spec.Limits"> & {
  /**
   * @generated from field: int64 max_iterations = 1;
   */
  maxIterations: bigint;

  /**
   * @generated from field: int64 max_output_tokens = 2;
   */
  maxOutputTokens: bigint;

  /**
   * @generated from field: int64 max_input_tokens = 3;
   */
  maxInputTokens: bigint;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Spec.Limits.
 * Use `create(AgentExecution_Spec_LimitsSchema)` to create a new message.
 */
export const AgentExecution_Spec_LimitsSchema: GenMessage<AgentExecution_Spec_Limits> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 1, 0);

/**
 * @generated from message gitpod.v1.AgentExecution.Spec.LoopCondition
 */
export type AgentExecution_Spec_LoopCondition = Message<"gitpod.v1.AgentExecution.Spec.LoopCondition"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string expression = 2;
   */
  expression: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Spec.LoopCondition.
 * Use `create(AgentExecution_Spec_LoopConditionSchema)` to create a new message.
 */
export const AgentExecution_Spec_LoopConditionSchema: GenMessage<AgentExecution_Spec_LoopCondition> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 1, 1);

/**
 * @generated from message gitpod.v1.AgentExecution.Status
 */
export type AgentExecution_Status = Message<"gitpod.v1.AgentExecution.Status"> & {
  /**
   * version of the status. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.status_version <
   * b.status_version then a was the status before b.
   *
   * @generated from field: uint64 status_version = 1;
   */
  statusVersion: bigint;

  /**
   * @generated from field: string session = 2;
   */
  session: string;

  /**
   * @generated from field: gitpod.v1.AgentExecution.Phase phase = 3;
   */
  phase: AgentExecution_Phase;

  /**
   * failure_message contains the reason the agent run failed to operate.
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage: string;

  /**
   * warning_message contains warnings, e.g. when the LLM is overloaded.
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage: string;

  /**
   * failure_reason contains a structured reason code for the failure.
   *
   * @generated from field: gitpod.v1.AgentExecutionFailureReason failure_reason = 6;
   */
  failureReason: AgentExecutionFailureReason;

  /**
   * conversation_url is the URL to the conversation (all messages exchanged between the agent and the user) of the agent run.
   *
   * @generated from field: string conversation_url = 10;
   */
  conversationUrl: string;

  /**
   * transcript_url is the URL to the LLM transcript (all messages exchanged between the agent and the LLM) of the agent run.
   *
   * @generated from field: string transcript_url = 11;
   */
  transcriptUrl: string;

  /**
   * support_bundle_url is the URL to download a diagnostic bundle for this agent execution.
   *
   * @generated from field: string support_bundle_url = 12;
   */
  supportBundleUrl: string;

  /**
   * @generated from field: int64 iterations = 20;
   */
  iterations: bigint;

  /**
   * @generated from field: int64 input_tokens_used = 21;
   */
  inputTokensUsed: bigint;

  /**
   * @generated from field: int64 output_tokens_used = 22;
   */
  outputTokensUsed: bigint;

  /**
   * @generated from field: int64 context_window_length = 23;
   */
  contextWindowLength: bigint;

  /**
   * @generated from field: int64 cached_creation_tokens_used = 24;
   */
  cachedCreationTokensUsed: bigint;

  /**
   * @generated from field: int64 cached_input_tokens_used = 25;
   */
  cachedInputTokensUsed: bigint;

  /**
   * judgement is the judgement of the agent run produced by the judgement prompt.
   *
   * @generated from field: string judgement = 30;
   */
  judgement: string;

  /**
   * current_operation is the current operation of the agent execution.
   *
   * @generated from field: gitpod.v1.AgentExecution.Status.CurrentOperation current_operation = 40;
   */
  currentOperation?: AgentExecution_Status_CurrentOperation;

  /**
   * used_environments is the list of environments that were used by the agent execution.
   *
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.EnvironmentUsage used_environments = 50;
   */
  usedEnvironments: AgentExecution_Status_EnvironmentUsage[];

  /**
   * current_activity is the current activity description of the agent execution.
   *
   * @generated from field: string current_activity = 60;
   */
  currentActivity: string;

  /**
   * outputs is a map of key-value pairs that can be set by the agent during execution.
   * Similar to task execution outputs, but with typed values for structured data.
   *
   * @generated from field: map<string, gitpod.v1.AgentExecution.Status.OutputValue> outputs = 70;
   */
  outputs: { [key: string]: AgentExecution_Status_OutputValue };

  /**
   * supported_model is the LLM model being used by the agent execution.
   *
   * @generated from field: gitpod.v1.SupportedModel supported_model = 80;
   */
  supportedModel: SupportedModel;

  /**
   * mode is the current operational mode of the agent execution.
   * This is set by the agent when entering different modes (e.g., Ralph mode via /ona:ralph command).
   *
   * @generated from field: gitpod.v1.AgentMode mode = 90;
   */
  mode: AgentMode;

  /**
   * mcp_integration_statuses contains the status of all MCP integrations used by this agent execution
   *
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.MCPIntegrationStatus mcp_integration_statuses = 100;
   */
  mcpIntegrationStatuses: AgentExecution_Status_MCPIntegrationStatus[];

  /**
   * waiting_info is set when phase is PHASE_WAITING_FOR_INPUT and the agent
   * has registered interests (timers, sub-agent completions, user messages).
   *
   * @generated from field: gitpod.v1.AgentExecution.WaitingInfo waiting_info = 110;
   */
  waitingInfo?: AgentExecution_WaitingInfo;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.LoopConditionResult loop_condition_results = 120;
   */
  loopConditionResults: AgentExecution_Status_LoopConditionResult[];

  /**
   * terminal_id is the ID of the terminal running the agent, if the agent runs as a terminal service (runsOn: terminal).
   *
   * @generated from field: string terminal_id = 130;
   */
  terminalId: string;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.
 * Use `create(AgentExecution_StatusSchema)` to create a new message.
 */
export const AgentExecution_StatusSchema: GenMessage<AgentExecution_Status> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2);

/**
 * @generated from message gitpod.v1.AgentExecution.Status.ToolUse
 */
export type AgentExecution_Status_ToolUse = Message<"gitpod.v1.AgentExecution.Status.ToolUse"> & {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName: string;

  /**
   * @generated from field: bool complete = 2;
   */
  complete: boolean;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.ToolUse.
 * Use `create(AgentExecution_Status_ToolUseSchema)` to create a new message.
 */
export const AgentExecution_Status_ToolUseSchema: GenMessage<AgentExecution_Status_ToolUse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 0);

/**
 * @generated from message gitpod.v1.AgentExecution.Status.LLM
 */
export type AgentExecution_Status_LLM = Message<"gitpod.v1.AgentExecution.Status.LLM"> & {
  /**
   * @generated from field: bool complete = 1;
   */
  complete: boolean;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.LLM.
 * Use `create(AgentExecution_Status_LLMSchema)` to create a new message.
 */
export const AgentExecution_Status_LLMSchema: GenMessage<AgentExecution_Status_LLM> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 1);

/**
 * @generated from message gitpod.v1.AgentExecution.Status.CurrentOperation
 */
export type AgentExecution_Status_CurrentOperation = Message<"gitpod.v1.AgentExecution.Status.CurrentOperation"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * retries is the number of times the agent run has retried one or more steps
   *
   * @generated from field: int64 retries = 2;
   */
  retries: bigint;

  /**
   * @generated from oneof gitpod.v1.AgentExecution.Status.CurrentOperation.operation
   */
  operation: {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status.ToolUse tool_use = 3;
     */
    value: AgentExecution_Status_ToolUse;
    case: "toolUse";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status.LLM llm = 4;
     */
    value: AgentExecution_Status_LLM;
    case: "llm";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.CurrentOperation.
 * Use `create(AgentExecution_Status_CurrentOperationSchema)` to create a new message.
 */
export const AgentExecution_Status_CurrentOperationSchema: GenMessage<AgentExecution_Status_CurrentOperation> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 2);

/**
 * @generated from message gitpod.v1.AgentExecution.Status.EnvironmentUsage
 */
export type AgentExecution_Status_EnvironmentUsage = Message<"gitpod.v1.AgentExecution.Status.EnvironmentUsage"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: bool created_by_agent = 2;
   */
  createdByAgent: boolean;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.EnvironmentUsage.
 * Use `create(AgentExecution_Status_EnvironmentUsageSchema)` to create a new message.
 */
export const AgentExecution_Status_EnvironmentUsageSchema: GenMessage<AgentExecution_Status_EnvironmentUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 3);

/**
 * @generated from message gitpod.v1.AgentExecution.Status.OutputValue
 */
export type AgentExecution_Status_OutputValue = Message<"gitpod.v1.AgentExecution.Status.OutputValue"> & {
  /**
   * @generated from oneof gitpod.v1.AgentExecution.Status.OutputValue.value
   */
  value: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int64 int_value = 2;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * @generated from field: double float_value = 3;
     */
    value: number;
    case: "floatValue";
  } | {
    /**
     * @generated from field: bool bool_value = 4;
     */
    value: boolean;
    case: "boolValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.OutputValue.
 * Use `create(AgentExecution_Status_OutputValueSchema)` to create a new message.
 */
export const AgentExecution_Status_OutputValueSchema: GenMessage<AgentExecution_Status_OutputValue> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 4);

/**
 * MCPIntegrationStatus represents the status of a single MCP integration
 * within an agent execution context
 *
 * @generated from message gitpod.v1.AgentExecution.Status.MCPIntegrationStatus
 */
export type AgentExecution_Status_MCPIntegrationStatus = Message<"gitpod.v1.AgentExecution.Status.MCPIntegrationStatus"> & {
  /**
   * id is the unique name of the MCP integration
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * name is the unique name of the MCP integration (e.g., "linear", "notion")
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * phase is the current connection/health phase
   *
   * @generated from field: gitpod.v1.MCPIntegrationPhase phase = 3;
   */
  phase: MCPIntegrationPhase;

  /**
   * failure_message contains the reason the MCP integration failed to connect or operate
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage: string;

  /**
   * warning_message contains warnings (e.g., rate limiting, degraded performance)
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage: string;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.MCPIntegrationStatus.
 * Use `create(AgentExecution_Status_MCPIntegrationStatusSchema)` to create a new message.
 */
export const AgentExecution_Status_MCPIntegrationStatusSchema: GenMessage<AgentExecution_Status_MCPIntegrationStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 5);

/**
 * @generated from message gitpod.v1.AgentExecution.Status.LoopConditionResult
 */
export type AgentExecution_Status_LoopConditionResult = Message<"gitpod.v1.AgentExecution.Status.LoopConditionResult"> & {
  /**
   * @generated from field: string condition_id = 1;
   */
  conditionId: string;

  /**
   * @generated from field: bool met = 2;
   */
  met: boolean;

  /**
   * @generated from field: int32 iteration = 3;
   */
  iteration: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_evaluated_at = 4;
   */
  lastEvaluatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.AgentExecution.Status.LoopConditionResult.
 * Use `create(AgentExecution_Status_LoopConditionResultSchema)` to create a new message.
 */
export const AgentExecution_Status_LoopConditionResultSchema: GenMessage<AgentExecution_Status_LoopConditionResult> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 2, 6);

/**
 * WaitingInfo describes what an agent is waiting for when in PHASE_WAITING_FOR_INPUT.
 *
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo
 */
export type AgentExecution_WaitingInfo = Message<"gitpod.v1.AgentExecution.WaitingInfo"> & {
  /**
   * @generated from field: string wait_id = 1;
   */
  waitId: string;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.WaitingInfo.Interest interests = 2;
   */
  interests: AgentExecution_WaitingInfo_Interest[];

  /**
   * @generated from field: google.protobuf.Timestamp waiting_since = 3;
   */
  waitingSince?: Timestamp;
};

/**
 * Describes the message gitpod.v1.AgentExecution.WaitingInfo.
 * Use `create(AgentExecution_WaitingInfoSchema)` to create a new message.
 */
export const AgentExecution_WaitingInfoSchema: GenMessage<AgentExecution_WaitingInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 3);

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.TimerInterest
 */
export type AgentExecution_WaitingInfo_TimerInterest = Message<"gitpod.v1.AgentExecution.WaitingInfo.TimerInterest"> & {
  /**
   * duration is the original duration spec (e.g. "5m"), if interval-based.
   *
   * @generated from field: string duration = 1;
   */
  duration: string;

  /**
   * cron is the cron expression, if cron-based.
   *
   * @generated from field: string cron = 2;
   */
  cron: string;

  /**
   * fires_at is the next fire time.
   *
   * @generated from field: google.protobuf.Timestamp fires_at = 3;
   */
  firesAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.AgentExecution.WaitingInfo.TimerInterest.
 * Use `create(AgentExecution_WaitingInfo_TimerInterestSchema)` to create a new message.
 */
export const AgentExecution_WaitingInfo_TimerInterestSchema: GenMessage<AgentExecution_WaitingInfo_TimerInterest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 3, 0);

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest
 */
export type AgentExecution_WaitingInfo_SubAgentInterest = Message<"gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest"> & {
  /**
   * @generated from field: string execution_id = 1;
   */
  executionId: string;
};

/**
 * Describes the message gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest.
 * Use `create(AgentExecution_WaitingInfo_SubAgentInterestSchema)` to create a new message.
 */
export const AgentExecution_WaitingInfo_SubAgentInterestSchema: GenMessage<AgentExecution_WaitingInfo_SubAgentInterest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 3, 1);

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest
 */
export type AgentExecution_WaitingInfo_UserMessageInterest = Message<"gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest"> & {
};

/**
 * Describes the message gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest.
 * Use `create(AgentExecution_WaitingInfo_UserMessageInterestSchema)` to create a new message.
 */
export const AgentExecution_WaitingInfo_UserMessageInterestSchema: GenMessage<AgentExecution_WaitingInfo_UserMessageInterest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 3, 2);

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.EnvironmentInterest
 */
export type AgentExecution_WaitingInfo_EnvironmentInterest = Message<"gitpod.v1.AgentExecution.WaitingInfo.EnvironmentInterest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * Optional. When empty, any terminal phase (running, stopped, deleted)
   * fires the interest. Valid values: "running", "stopped", "deleted".
   *
   * @generated from field: string phase = 2;
   */
  phase: string;
};

/**
 * Describes the message gitpod.v1.AgentExecution.WaitingInfo.EnvironmentInterest.
 * Use `create(AgentExecution_WaitingInfo_EnvironmentInterestSchema)` to create a new message.
 */
export const AgentExecution_WaitingInfo_EnvironmentInterestSchema: GenMessage<AgentExecution_WaitingInfo_EnvironmentInterest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 3, 3);

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.Interest
 */
export type AgentExecution_WaitingInfo_Interest = Message<"gitpod.v1.AgentExecution.WaitingInfo.Interest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof gitpod.v1.AgentExecution.WaitingInfo.Interest.interest
   */
  interest: {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.TimerInterest timer = 2;
     */
    value: AgentExecution_WaitingInfo_TimerInterest;
    case: "timer";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest sub_agent = 3;
     */
    value: AgentExecution_WaitingInfo_SubAgentInterest;
    case: "subAgent";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest user_message = 4;
     */
    value: AgentExecution_WaitingInfo_UserMessageInterest;
    case: "userMessage";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.EnvironmentInterest environment = 5;
     */
    value: AgentExecution_WaitingInfo_EnvironmentInterest;
    case: "environment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.AgentExecution.WaitingInfo.Interest.
 * Use `create(AgentExecution_WaitingInfo_InterestSchema)` to create a new message.
 */
export const AgentExecution_WaitingInfo_InterestSchema: GenMessage<AgentExecution_WaitingInfo_Interest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 16, 3, 4);

/**
 * @generated from enum gitpod.v1.AgentExecution.Phase
 */
export enum AgentExecution_Phase {
  /**
   * The phase is not set.
   *
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The agent run is pending.
   *
   * @generated from enum value: PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * The agent run is active.
   *
   * @generated from enum value: PHASE_RUNNING = 20;
   */
  RUNNING = 20,

  /**
   * The agent run is waiting for input.
   *
   * @generated from enum value: PHASE_WAITING_FOR_INPUT = 30;
   */
  WAITING_FOR_INPUT = 30,

  /**
   * The agent run is inactive.
   *
   * @generated from enum value: PHASE_STOPPED = 40;
   */
  STOPPED = 40,
}

/**
 * Describes the enum gitpod.v1.AgentExecution.Phase.
 */
export const AgentExecution_PhaseSchema: GenEnum<AgentExecution_Phase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 16, 0);

/**
 * @generated from message gitpod.v1.ClarifyingQuestions
 */
export type ClarifyingQuestions = Message<"gitpod.v1.ClarifyingQuestions"> & {
  /**
   * @generated from field: repeated gitpod.v1.ClarifyingQuestions.Question questions = 1;
   */
  questions: ClarifyingQuestions_Question[];
};

/**
 * Describes the message gitpod.v1.ClarifyingQuestions.
 * Use `create(ClarifyingQuestionsSchema)` to create a new message.
 */
export const ClarifyingQuestionsSchema: GenMessage<ClarifyingQuestions> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 17);

/**
 * @generated from message gitpod.v1.ClarifyingQuestions.Choice
 */
export type ClarifyingQuestions_Choice = Message<"gitpod.v1.ClarifyingQuestions.Choice"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message gitpod.v1.ClarifyingQuestions.Choice.
 * Use `create(ClarifyingQuestions_ChoiceSchema)` to create a new message.
 */
export const ClarifyingQuestions_ChoiceSchema: GenMessage<ClarifyingQuestions_Choice> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 17, 0);

/**
 * @generated from message gitpod.v1.ClarifyingQuestions.Question
 */
export type ClarifyingQuestions_Question = Message<"gitpod.v1.ClarifyingQuestions.Question"> & {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId: string;

  /**
   * @generated from field: string question = 2;
   */
  question: string;

  /**
   * @generated from field: repeated gitpod.v1.ClarifyingQuestions.Choice choices = 3;
   */
  choices: ClarifyingQuestions_Choice[];

  /**
   * @generated from field: bool allow_other = 4;
   */
  allowOther: boolean;
};

/**
 * Describes the message gitpod.v1.ClarifyingQuestions.Question.
 * Use `create(ClarifyingQuestions_QuestionSchema)` to create a new message.
 */
export const ClarifyingQuestions_QuestionSchema: GenMessage<ClarifyingQuestions_Question> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 17, 1);

/**
 * @generated from message gitpod.v1.NextStepsProposal
 */
export type NextStepsProposal = Message<"gitpod.v1.NextStepsProposal"> & {
  /**
   * @generated from field: repeated gitpod.v1.NextStepsProposal.Action actions = 1;
   */
  actions: NextStepsProposal_Action[];
};

/**
 * Describes the message gitpod.v1.NextStepsProposal.
 * Use `create(NextStepsProposalSchema)` to create a new message.
 */
export const NextStepsProposalSchema: GenMessage<NextStepsProposal> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 18);

/**
 * @generated from message gitpod.v1.NextStepsProposal.Action
 */
export type NextStepsProposal_Action = Message<"gitpod.v1.NextStepsProposal.Action"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: string variant = 3;
   */
  variant: string;
};

/**
 * Describes the message gitpod.v1.NextStepsProposal.Action.
 * Use `create(NextStepsProposal_ActionSchema)` to create a new message.
 */
export const NextStepsProposal_ActionSchema: GenMessage<NextStepsProposal_Action> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 18, 0);

/**
 * @generated from message gitpod.v1.AgentResponseBlock
 */
export type AgentResponseBlock = Message<"gitpod.v1.AgentResponseBlock"> & {
  /**
   * id is the unique identifier of the response block. A conversation can have multiple blocks with the same ID.
   * Clients are expected to use the ID to update or replace a block.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * phase is the phase of the response block indicating how to update the previous output block with the same ID.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.Phase phase = 2;
   */
  phase: AgentResponseBlock_Phase;

  /**
   * @generated from oneof gitpod.v1.AgentResponseBlock.output
   */
  output: {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.UserInputBlockSeen user_input_seen = 8;
     */
    value: AgentResponseBlock_UserInputBlockSeen;
    case: "userInputSeen";
  } | {
    /**
     * @generated from field: gitpod.v1.UserInputBlock user_input = 9;
     */
    value: UserInputBlock;
    case: "userInput";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TextOutput text = 10;
     */
    value: AgentResponseBlock_TextOutput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.ActionStarted action_started = 20;
     */
    value: AgentResponseBlock_ActionStarted;
    case: "actionStarted";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.ActionCompleted action_completed = 21;
     */
    value: AgentResponseBlock_ActionCompleted;
    case: "actionCompleted";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.FileModification file_modification = 30;
     */
    value: AgentResponseBlock_FileModification;
    case: "fileModification";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.EnvironmentCreation environment_creation = 40;
     */
    value: AgentResponseBlock_EnvironmentCreation;
    case: "environmentCreation";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.CodeAnnotation code_annotation = 50;
     */
    value: AgentResponseBlock_CodeAnnotation;
    case: "codeAnnotation";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.HostAuthenticationRequired host_authentication_required = 60;
     */
    value: AgentResponseBlock_HostAuthenticationRequired;
    case: "hostAuthenticationRequired";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TodoGroup todo_group = 65;
     */
    value: AgentResponseBlock_TodoGroup;
    case: "todoGroup";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TodoItem todo_item = 70;
     */
    value: AgentResponseBlock_TodoItem;
    case: "todoItem";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.Thought thought = 80;
     */
    value: AgentResponseBlock_Thought;
    case: "thought";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.AgentModeChange agent_mode_change = 90;
     */
    value: AgentResponseBlock_AgentModeChange;
    case: "agentModeChange";
  } | {
    /**
     * @generated from field: gitpod.v1.ClarifyingQuestions clarifying_questions = 91;
     */
    value: ClarifyingQuestions;
    case: "clarifyingQuestions";
  } | {
    /**
     * @generated from field: gitpod.v1.NextStepsProposal next_steps_proposal = 92;
     */
    value: NextStepsProposal;
    case: "nextStepsProposal";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.AvailableCommands available_commands = 93;
     */
    value: AgentResponseBlock_AvailableCommands;
    case: "availableCommands";
  } | { case: undefined; value?: undefined };

  /**
   * Timestamp when this block was created. Used for debugging and support bundles.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 100;
   */
  createdAt?: Timestamp;

  /**
   * Active todo snapshot group for routing response fragments in snapshot mode.
   *
   * @generated from field: string todo_group_id = 110;
   */
  todoGroupId: string;

  /**
   * Active in-progress todo item for routing response fragments in snapshot mode.
   *
   * @generated from field: string todo_item_id = 111;
   */
  todoItemId: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.
 * Use `create(AgentResponseBlockSchema)` to create a new message.
 */
export const AgentResponseBlockSchema: GenMessage<AgentResponseBlock> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TextOutput
 */
export type AgentResponseBlock_TextOutput = Message<"gitpod.v1.AgentResponseBlock.TextOutput"> & {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.TextOutput.Type type = 1;
   */
  type: AgentResponseBlock_TextOutput_Type;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * Sequence ID for deduplication within the same message. Starts from 1, with 0 indicating unset (backwards compatible).
   *
   * @generated from field: uint64 sequence_id = 3;
   */
  sequenceId: bigint;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.TextOutput.
 * Use `create(AgentResponseBlock_TextOutputSchema)` to create a new message.
 */
export const AgentResponseBlock_TextOutputSchema: GenMessage<AgentResponseBlock_TextOutput> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 0);

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.TextOutput.Type
 */
export enum AgentResponseBlock_TextOutput_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_USER_FACING_OUTPUT = 1;
   */
  USER_FACING_OUTPUT = 1,

  /**
   * @generated from enum value: TYPE_THOUGHTS = 2;
   */
  THOUGHTS = 2,
}

/**
 * Describes the enum gitpod.v1.AgentResponseBlock.TextOutput.Type.
 */
export const AgentResponseBlock_TextOutput_TypeSchema: GenEnum<AgentResponseBlock_TextOutput_Type> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 19, 0, 0);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.ActionStarted
 */
export type AgentResponseBlock_ActionStarted = Message<"gitpod.v1.AgentResponseBlock.ActionStarted"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string intent_description = 2;
   */
  intentDescription: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.ActionStarted.
 * Use `create(AgentResponseBlock_ActionStartedSchema)` to create a new message.
 */
export const AgentResponseBlock_ActionStartedSchema: GenMessage<AgentResponseBlock_ActionStarted> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 1);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.ActionCompleted
 */
export type AgentResponseBlock_ActionCompleted = Message<"gitpod.v1.AgentResponseBlock.ActionCompleted"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string result_description = 2;
   */
  resultDescription: string;

  /**
   * @generated from field: bool failed = 3;
   */
  failed: boolean;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.ActionCompleted.
 * Use `create(AgentResponseBlock_ActionCompletedSchema)` to create a new message.
 */
export const AgentResponseBlock_ActionCompletedSchema: GenMessage<AgentResponseBlock_ActionCompleted> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 2);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification
 */
export type AgentResponseBlock_FileModification = Message<"gitpod.v1.AgentResponseBlock.FileModification"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string file_path = 2;
   */
  filePath: string;

  /**
   * Legacy SEARCH/REPLACE format content (deprecated in favor of diff)
   *
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: int32 start_line = 4;
   */
  startLine: number;

  /**
   * Enhanced diff format for dashboard consumption.
   * When present, the dashboard will use this instead of parsing the content field.
   * This provides better performance and more accurate diff rendering.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.FileModification.Diff diff = 5;
   */
  diff?: AgentResponseBlock_FileModification_Diff;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.FileModification.
 * Use `create(AgentResponseBlock_FileModificationSchema)` to create a new message.
 */
export const AgentResponseBlock_FileModificationSchema: GenMessage<AgentResponseBlock_FileModification> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 3);

/**
 * DiffGroup represents a contiguous block of lines with the same change type
 *
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification.DiffGroup
 */
export type AgentResponseBlock_FileModification_DiffGroup = Message<"gitpod.v1.AgentResponseBlock.FileModification.DiffGroup"> & {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.Type type = 1;
   */
  type: AgentResponseBlock_FileModification_DiffGroup_Type;

  /**
   * The actual lines of code for this group
   *
   * @generated from field: repeated string lines = 2;
   */
  lines: string[];
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.
 * Use `create(AgentResponseBlock_FileModification_DiffGroupSchema)` to create a new message.
 */
export const AgentResponseBlock_FileModification_DiffGroupSchema: GenMessage<AgentResponseBlock_FileModification_DiffGroup> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 3, 0);

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.Type
 */
export enum AgentResponseBlock_FileModification_DiffGroup_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Lines that were added in the new version
   *
   * @generated from enum value: TYPE_ADDED = 1;
   */
  ADDED = 1,

  /**
   * Lines that were removed from the old version
   *
   * @generated from enum value: TYPE_REMOVED = 2;
   */
  REMOVED = 2,

  /**
   * Lines that remain unchanged between versions
   *
   * @generated from enum value: TYPE_UNCHANGED = 3;
   */
  UNCHANGED = 3,
}

/**
 * Describes the enum gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.Type.
 */
export const AgentResponseBlock_FileModification_DiffGroup_TypeSchema: GenEnum<AgentResponseBlock_FileModification_DiffGroup_Type> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 19, 3, 0, 0);

/**
 * Statistics about the changes in the diff
 *
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification.DiffStats
 */
export type AgentResponseBlock_FileModification_DiffStats = Message<"gitpod.v1.AgentResponseBlock.FileModification.DiffStats"> & {
  /**
   * Number of lines added
   *
   * @generated from field: int32 additions = 1;
   */
  additions: number;

  /**
   * Number of lines deleted
   *
   * @generated from field: int32 deletions = 2;
   */
  deletions: number;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.FileModification.DiffStats.
 * Use `create(AgentResponseBlock_FileModification_DiffStatsSchema)` to create a new message.
 */
export const AgentResponseBlock_FileModification_DiffStatsSchema: GenMessage<AgentResponseBlock_FileModification_DiffStats> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 3, 1);

/**
 * Diff provides a structured diff format optimized for dashboard consumption.
 * This format allows the dashboard to render diffs efficiently without parsing
 * the legacy SEARCH/REPLACE format in the content field.
 *
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification.Diff
 */
export type AgentResponseBlock_FileModification_Diff = Message<"gitpod.v1.AgentResponseBlock.FileModification.Diff"> & {
  /**
   * Structured diff groups for efficient rendering
   *
   * @generated from field: repeated gitpod.v1.AgentResponseBlock.FileModification.DiffGroup diff_groups = 1;
   */
  diffGroups: AgentResponseBlock_FileModification_DiffGroup[];

  /**
   * Summary statistics for the diff
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.FileModification.DiffStats stats = 2;
   */
  stats?: AgentResponseBlock_FileModification_DiffStats;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.FileModification.Diff.
 * Use `create(AgentResponseBlock_FileModification_DiffSchema)` to create a new message.
 */
export const AgentResponseBlock_FileModification_DiffSchema: GenMessage<AgentResponseBlock_FileModification_Diff> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 3, 2);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.EnvironmentCreation
 */
export type AgentResponseBlock_EnvironmentCreation = Message<"gitpod.v1.AgentResponseBlock.EnvironmentCreation"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.EnvironmentCreation.
 * Use `create(AgentResponseBlock_EnvironmentCreationSchema)` to create a new message.
 */
export const AgentResponseBlock_EnvironmentCreationSchema: GenMessage<AgentResponseBlock_EnvironmentCreation> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 4);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.HostAuthenticationRequired
 */
export type AgentResponseBlock_HostAuthenticationRequired = Message<"gitpod.v1.AgentResponseBlock.HostAuthenticationRequired"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * @generated from field: string runner_id = 3;
   */
  runnerId: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.HostAuthenticationRequired.
 * Use `create(AgentResponseBlock_HostAuthenticationRequiredSchema)` to create a new message.
 */
export const AgentResponseBlock_HostAuthenticationRequiredSchema: GenMessage<AgentResponseBlock_HostAuthenticationRequired> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 5);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.CodeAnnotation
 */
export type AgentResponseBlock_CodeAnnotation = Message<"gitpod.v1.AgentResponseBlock.CodeAnnotation"> & {
  /**
   * @generated from field: string file_path = 1;
   */
  filePath: string;

  /**
   * @generated from field: int32 start_line = 2;
   */
  startLine: number;

  /**
   * @generated from field: int32 end_line = 3;
   */
  endLine: number;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.CodeAnnotation.
 * Use `create(AgentResponseBlock_CodeAnnotationSchema)` to create a new message.
 */
export const AgentResponseBlock_CodeAnnotationSchema: GenMessage<AgentResponseBlock_CodeAnnotation> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 6);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TodoGroup
 */
export type AgentResponseBlock_TodoGroup = Message<"gitpod.v1.AgentResponseBlock.TodoGroup"> & {
  /**
   * Agent-controlled identifier for snapshot replacement semantics.
   *
   * @generated from field: string group_id = 1;
   */
  groupId: string;

  /**
   * Timestamp of the latest snapshot update.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * Complete todo snapshot for this group.
   *
   * @generated from field: repeated gitpod.v1.AgentResponseBlock.TodoItem todos = 3;
   */
  todos: AgentResponseBlock_TodoItem[];
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.TodoGroup.
 * Use `create(AgentResponseBlock_TodoGroupSchema)` to create a new message.
 */
export const AgentResponseBlock_TodoGroupSchema: GenMessage<AgentResponseBlock_TodoGroup> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 7);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TodoItem
 */
export type AgentResponseBlock_TodoItem = Message<"gitpod.v1.AgentResponseBlock.TodoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.TodoItem.Phase phase = 3;
   */
  phase: AgentResponseBlock_TodoItem_Phase;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.TodoItem.
 * Use `create(AgentResponseBlock_TodoItemSchema)` to create a new message.
 */
export const AgentResponseBlock_TodoItemSchema: GenMessage<AgentResponseBlock_TodoItem> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 8);

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.TodoItem.Phase
 */
export enum AgentResponseBlock_TodoItem_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PHASE_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: PHASE_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: PHASE_CLEARED = 4;
   */
  CLEARED = 4,
}

/**
 * Describes the enum gitpod.v1.AgentResponseBlock.TodoItem.Phase.
 */
export const AgentResponseBlock_TodoItem_PhaseSchema: GenEnum<AgentResponseBlock_TodoItem_Phase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 19, 8, 0);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.Thought
 */
export type AgentResponseBlock_Thought = Message<"gitpod.v1.AgentResponseBlock.Thought"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.Thought.
 * Use `create(AgentResponseBlock_ThoughtSchema)` to create a new message.
 */
export const AgentResponseBlock_ThoughtSchema: GenMessage<AgentResponseBlock_Thought> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 9);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.UserInputBlockSeen
 */
export type AgentResponseBlock_UserInputBlockSeen = Message<"gitpod.v1.AgentResponseBlock.UserInputBlockSeen"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.UserInputBlockSeen.
 * Use `create(AgentResponseBlock_UserInputBlockSeenSchema)` to create a new message.
 */
export const AgentResponseBlock_UserInputBlockSeenSchema: GenMessage<AgentResponseBlock_UserInputBlockSeen> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 10);

/**
 * AgentModeChange signals a mode transition in autonomous agent modes (e.g., Ralph mode).
 * This provides structured signaling instead of parsing magic tokens from text output.
 *
 * @generated from message gitpod.v1.AgentResponseBlock.AgentModeChange
 */
export type AgentResponseBlock_AgentModeChange = Message<"gitpod.v1.AgentResponseBlock.AgentModeChange"> & {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.AgentModeChange.State state = 1;
   */
  state: AgentResponseBlock_AgentModeChange_State;

  /**
   * Human-readable message describing the mode change
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.AgentModeChange.
 * Use `create(AgentResponseBlock_AgentModeChangeSchema)` to create a new message.
 */
export const AgentResponseBlock_AgentModeChangeSchema: GenMessage<AgentResponseBlock_AgentModeChange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 11);

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.AgentModeChange.State
 */
export enum AgentResponseBlock_AgentModeChange_State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Spec is complete, transitioning to implementation phase (Ralph mode)
   *
   * @generated from enum value: STATE_SPEC_COMPLETE = 1;
   */
  SPEC_COMPLETE = 1,

  /**
   * Implementation iteration complete, more work needed
   *
   * @generated from enum value: STATE_ITERATION_COMPLETE = 2;
   */
  ITERATION_COMPLETE = 2,

  /**
   * Autonomous mode fully complete
   *
   * @generated from enum value: STATE_COMPLETE = 3;
   */
  COMPLETE = 3,

  /**
   * Spec mode complete, transitioning to normal interactive mode
   *
   * @generated from enum value: STATE_ONA_SPEC_COMPLETE = 4;
   */
  ONA_SPEC_COMPLETE = 4,
}

/**
 * Describes the enum gitpod.v1.AgentResponseBlock.AgentModeChange.State.
 */
export const AgentResponseBlock_AgentModeChange_StateSchema: GenEnum<AgentResponseBlock_AgentModeChange_State> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 19, 11, 0);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.AvailableCommand
 */
export type AgentResponseBlock_AvailableCommand = Message<"gitpod.v1.AgentResponseBlock.AvailableCommand"> & {
  /**
   * The command name without the leading slash (e.g., "go-tests", "create-pr")
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Human-readable description of what the command does
   *
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.AvailableCommand.
 * Use `create(AgentResponseBlock_AvailableCommandSchema)` to create a new message.
 */
export const AgentResponseBlock_AvailableCommandSchema: GenMessage<AgentResponseBlock_AvailableCommand> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 12);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.AvailableCommands
 */
export type AgentResponseBlock_AvailableCommands = Message<"gitpod.v1.AgentResponseBlock.AvailableCommands"> & {
  /**
   * @generated from field: repeated gitpod.v1.AgentResponseBlock.AvailableCommand commands = 1;
   */
  commands: AgentResponseBlock_AvailableCommand[];
};

/**
 * Describes the message gitpod.v1.AgentResponseBlock.AvailableCommands.
 * Use `create(AgentResponseBlock_AvailableCommandsSchema)` to create a new message.
 */
export const AgentResponseBlock_AvailableCommandsSchema: GenMessage<AgentResponseBlock_AvailableCommands> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 19, 13);

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.Phase
 */
export enum AgentResponseBlock_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Update replaces the previous output block with the same ID.
   *
   * @generated from enum value: PHASE_UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * Completed indicates that the output block is complete - it overrides any previous output block with the same ID.
   *
   * @generated from enum value: PHASE_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * Delta indicates that the output block is a delta to the previous output block; append to the previous output block.
   *
   * @generated from enum value: PHASE_DELTA = 3;
   */
  DELTA = 3,
}

/**
 * Describes the enum gitpod.v1.AgentResponseBlock.Phase.
 */
export const AgentResponseBlock_PhaseSchema: GenEnum<AgentResponseBlock_Phase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 19, 0);

/**
 * @generated from message gitpod.v1.UserInputBlock
 */
export type UserInputBlock = Message<"gitpod.v1.UserInputBlock"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof gitpod.v1.UserInputBlock.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.TextInput text = 20 [deprecated = true];
     * @deprecated
     */
    value: UserInputBlock_TextInput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.ImageInput image = 21 [deprecated = true];
     * @deprecated
     */
    value: UserInputBlock_ImageInput;
    case: "image";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated gitpod.v1.UserInputBlock.Input inputs = 30;
   */
  inputs: UserInputBlock_Input[];

  /**
   * Timestamp when this block was created. Used for debugging and support bundles.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 100;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.UserInputBlock.
 * Use `create(UserInputBlockSchema)` to create a new message.
 */
export const UserInputBlockSchema: GenMessage<UserInputBlock> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 20);

/**
 * @generated from message gitpod.v1.UserInputBlock.TextInput
 */
export type UserInputBlock_TextInput = Message<"gitpod.v1.UserInputBlock.TextInput"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;
};

/**
 * Describes the message gitpod.v1.UserInputBlock.TextInput.
 * Use `create(UserInputBlock_TextInputSchema)` to create a new message.
 */
export const UserInputBlock_TextInputSchema: GenMessage<UserInputBlock_TextInput> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 20, 0);

/**
 * ImageInput allows sending images to the agent.
 * Client must provide the MIME type; backend validates against magic bytes.
 *
 * @generated from message gitpod.v1.UserInputBlock.ImageInput
 */
export type UserInputBlock_ImageInput = Message<"gitpod.v1.UserInputBlock.ImageInput"> & {
  /**
   * Raw image data (max 4MB). Supported formats: PNG, JPEG.
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;

  /**
   * Content-addressed reference to offloaded image data.
   * Set by the runner when storing in the conversation store; data is cleared.
   * Clients never send this field.
   *
   * @generated from field: string data_ref = 3;
   */
  dataRef: string;
};

/**
 * Describes the message gitpod.v1.UserInputBlock.ImageInput.
 * Use `create(UserInputBlock_ImageInputSchema)` to create a new message.
 */
export const UserInputBlock_ImageInputSchema: GenMessage<UserInputBlock_ImageInput> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 20, 1);

/**
 * @generated from message gitpod.v1.UserInputBlock.Input
 */
export type UserInputBlock_Input = Message<"gitpod.v1.UserInputBlock.Input"> & {
  /**
   * @generated from oneof gitpod.v1.UserInputBlock.Input.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.TextInput text = 20;
     */
    value: UserInputBlock_TextInput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.ImageInput image = 21;
     */
    value: UserInputBlock_ImageInput;
    case: "image";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.UserInputBlock.Input.
 * Use `create(UserInputBlock_InputSchema)` to create a new message.
 */
export const UserInputBlock_InputSchema: GenMessage<UserInputBlock_Input> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 20, 2);

/**
 * AgentMessage is a message sent between agents (e.g. from a parent agent to a
 * child agent execution, or vice versa).
 *
 * @generated from message gitpod.v1.AgentMessage
 */
export type AgentMessage = Message<"gitpod.v1.AgentMessage"> & {
  /**
   * @generated from field: gitpod.v1.AgentMessage.Type type = 1;
   */
  type: AgentMessage_Type;

  /**
   * Free-form payload of the message.
   *
   * @generated from field: string payload = 2;
   */
  payload: string;

  /**
   * The role of the sender in the agent hierarchy.
   *
   * @generated from field: gitpod.v1.AgentMessage.Role role = 3;
   */
  role: AgentMessage_Role;

  /**
   * The execution ID of the agent that sent this message.
   *
   * @generated from field: string sender_execution_id = 4;
   */
  senderExecutionId: string;
};

/**
 * Describes the message gitpod.v1.AgentMessage.
 * Use `create(AgentMessageSchema)` to create a new message.
 */
export const AgentMessageSchema: GenMessage<AgentMessage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 21);

/**
 * @generated from enum gitpod.v1.AgentMessage.Type
 */
export enum AgentMessage_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Regular inter-agent update message.
   *
   * @generated from enum value: TYPE_UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * Signals that the sending agent has completed its task.
   *
   * @generated from enum value: TYPE_COMPLETE = 2;
   */
  COMPLETE = 2,
}

/**
 * Describes the enum gitpod.v1.AgentMessage.Type.
 */
export const AgentMessage_TypeSchema: GenEnum<AgentMessage_Type> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 21, 0);

/**
 * Role identifies the sender's relationship in the parent/child hierarchy.
 *
 * @generated from enum gitpod.v1.AgentMessage.Role
 */
export enum AgentMessage_Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The sender is the parent agent.
   *
   * @generated from enum value: ROLE_PARENT = 1;
   */
  PARENT = 1,

  /**
   * The sender is a child (sub-agent).
   *
   * @generated from enum value: ROLE_CHILD = 2;
   */
  CHILD = 2,
}

/**
 * Describes the enum gitpod.v1.AgentMessage.Role.
 */
export const AgentMessage_RoleSchema: GenEnum<AgentMessage_Role> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 21, 1);

/**
 * WakeEvent is sent by the backend to wake an agent when a registered interest fires.
 * Delivered via SendToAgentExecution as a new oneof variant.
 *
 * @generated from message gitpod.v1.WakeEvent
 */
export type WakeEvent = Message<"gitpod.v1.WakeEvent"> & {
  /**
   * The interest ID that fired (from WaitingInfo.Interest.id).
   *
   * @generated from field: string interest_id = 1;
   */
  interestId: string;

  /**
   * Interest-specific payload describing what fired.
   *
   * @generated from oneof gitpod.v1.WakeEvent.payload
   */
  payload: {
    /**
     * @generated from field: gitpod.v1.WakeEvent.TimerFired timer = 2;
     */
    value: WakeEvent_TimerFired;
    case: "timer";
  } | {
    /**
     * @generated from field: gitpod.v1.WakeEvent.LoopRetrigger loop_retrigger = 3;
     */
    value: WakeEvent_LoopRetrigger;
    case: "loopRetrigger";
  } | {
    /**
     * @generated from field: gitpod.v1.WakeEvent.EnvironmentPhaseReached environment = 4;
     */
    value: WakeEvent_EnvironmentPhaseReached;
    case: "environment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.WakeEvent.
 * Use `create(WakeEventSchema)` to create a new message.
 */
export const WakeEventSchema: GenMessage<WakeEvent> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 22);

/**
 * @generated from message gitpod.v1.WakeEvent.TimerFired
 */
export type WakeEvent_TimerFired = Message<"gitpod.v1.WakeEvent.TimerFired"> & {
  /**
   * The actual time the timer was evaluated as expired.
   *
   * @generated from field: google.protobuf.Timestamp fired_at = 1;
   */
  firedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.WakeEvent.TimerFired.
 * Use `create(WakeEvent_TimerFiredSchema)` to create a new message.
 */
export const WakeEvent_TimerFiredSchema: GenMessage<WakeEvent_TimerFired> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 22, 0);

/**
 * @generated from message gitpod.v1.WakeEvent.LoopRetrigger
 */
export type WakeEvent_LoopRetrigger = Message<"gitpod.v1.WakeEvent.LoopRetrigger"> & {
  /**
   * @generated from field: repeated gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition unmet_conditions = 1;
   */
  unmetConditions: WakeEvent_LoopRetrigger_UnmetCondition[];

  /**
   * @generated from field: map<string, string> outputs = 2;
   */
  outputs: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.WakeEvent.LoopRetrigger.
 * Use `create(WakeEvent_LoopRetriggerSchema)` to create a new message.
 */
export const WakeEvent_LoopRetriggerSchema: GenMessage<WakeEvent_LoopRetrigger> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 22, 1);

/**
 * @generated from message gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition
 */
export type WakeEvent_LoopRetrigger_UnmetCondition = Message<"gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string expression = 2;
   */
  expression: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int32 iteration = 4;
   */
  iteration: number;

  /**
   * @generated from field: int32 max_iterations = 5;
   */
  maxIterations: number;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition.
 * Use `create(WakeEvent_LoopRetrigger_UnmetConditionSchema)` to create a new message.
 */
export const WakeEvent_LoopRetrigger_UnmetConditionSchema: GenMessage<WakeEvent_LoopRetrigger_UnmetCondition> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 22, 1, 0);

/**
 * @generated from message gitpod.v1.WakeEvent.EnvironmentPhaseReached
 */
export type WakeEvent_EnvironmentPhaseReached = Message<"gitpod.v1.WakeEvent.EnvironmentPhaseReached"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * The phase the environment reached (e.g. "running", "stopped", "deleted").
   *
   * @generated from field: string phase = 2;
   */
  phase: string;

  /**
   * @generated from field: repeated string failure_message = 3;
   */
  failureMessage: string[];
};

/**
 * Describes the message gitpod.v1.WakeEvent.EnvironmentPhaseReached.
 * Use `create(WakeEvent_EnvironmentPhaseReachedSchema)` to create a new message.
 */
export const WakeEvent_EnvironmentPhaseReachedSchema: GenMessage<WakeEvent_EnvironmentPhaseReached> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 22, 2);

/**
 * @generated from message gitpod.v1.SendToAgentExecutionRequest
 */
export type SendToAgentExecutionRequest = Message<"gitpod.v1.SendToAgentExecutionRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * @generated from oneof gitpod.v1.SendToAgentExecutionRequest.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock user_input = 2;
     */
    value: UserInputBlock;
    case: "userInput";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentMessage agent_message = 3;
     */
    value: AgentMessage;
    case: "agentMessage";
  } | {
    /**
     * @generated from field: gitpod.v1.WakeEvent wake_event = 4;
     */
    value: WakeEvent;
    case: "wakeEvent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.SendToAgentExecutionRequest.
 * Use `create(SendToAgentExecutionRequestSchema)` to create a new message.
 */
export const SendToAgentExecutionRequestSchema: GenMessage<SendToAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 23);

/**
 * @generated from message gitpod.v1.SendToAgentExecutionResponse
 */
export type SendToAgentExecutionResponse = Message<"gitpod.v1.SendToAgentExecutionResponse"> & {
};

/**
 * Describes the message gitpod.v1.SendToAgentExecutionResponse.
 * Use `create(SendToAgentExecutionResponseSchema)` to create a new message.
 */
export const SendToAgentExecutionResponseSchema: GenMessage<SendToAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 24);

/**
 * PromptValidationErrorDetails is returned as an error detail on INVALID_ARGUMENT
 * when a prompt contains deceptive Unicode characters (e.g. bidi overrides).
 * The frontend uses this to offer a one-click fix.
 *
 * @generated from message gitpod.v1.PromptValidationErrorDetails
 */
export type PromptValidationErrorDetails = Message<"gitpod.v1.PromptValidationErrorDetails"> & {
  /**
   * The prompt content with deceptive characters removed.
   *
   * @generated from field: string cleaned_text = 1;
   */
  cleanedText: string;

  /**
   * The number of deceptive characters that were removed.
   *
   * @generated from field: int32 removed_count = 2;
   */
  removedCount: number;
};

/**
 * Describes the message gitpod.v1.PromptValidationErrorDetails.
 * Use `create(PromptValidationErrorDetailsSchema)` to create a new message.
 */
export const PromptValidationErrorDetailsSchema: GenMessage<PromptValidationErrorDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 25);

/**
 * @generated from message gitpod.v1.CreateAgentExecutionConversationTokenRequest
 */
export type CreateAgentExecutionConversationTokenRequest = Message<"gitpod.v1.CreateAgentExecutionConversationTokenRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.CreateAgentExecutionConversationTokenRequest.
 * Use `create(CreateAgentExecutionConversationTokenRequestSchema)` to create a new message.
 */
export const CreateAgentExecutionConversationTokenRequestSchema: GenMessage<CreateAgentExecutionConversationTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 26);

/**
 * @generated from message gitpod.v1.CreateAgentExecutionConversationTokenResponse
 */
export type CreateAgentExecutionConversationTokenResponse = Message<"gitpod.v1.CreateAgentExecutionConversationTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.CreateAgentExecutionConversationTokenResponse.
 * Use `create(CreateAgentExecutionConversationTokenResponseSchema)` to create a new message.
 */
export const CreateAgentExecutionConversationTokenResponseSchema: GenMessage<CreateAgentExecutionConversationTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 27);

/**
 * @generated from message gitpod.v1.CreateAgentExecutionTranscriptTokenRequest
 */
export type CreateAgentExecutionTranscriptTokenRequest = Message<"gitpod.v1.CreateAgentExecutionTranscriptTokenRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.CreateAgentExecutionTranscriptTokenRequest.
 * Use `create(CreateAgentExecutionTranscriptTokenRequestSchema)` to create a new message.
 */
export const CreateAgentExecutionTranscriptTokenRequestSchema: GenMessage<CreateAgentExecutionTranscriptTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 28);

/**
 * @generated from message gitpod.v1.CreateAgentExecutionTranscriptTokenResponse
 */
export type CreateAgentExecutionTranscriptTokenResponse = Message<"gitpod.v1.CreateAgentExecutionTranscriptTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.CreateAgentExecutionTranscriptTokenResponse.
 * Use `create(CreateAgentExecutionTranscriptTokenResponseSchema)` to create a new message.
 */
export const CreateAgentExecutionTranscriptTokenResponseSchema: GenMessage<CreateAgentExecutionTranscriptTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 29);

/**
 * @generated from message gitpod.v1.RunnerSideAgentSpec
 */
export type RunnerSideAgentSpec = Message<"gitpod.v1.RunnerSideAgentSpec"> & {
  /**
   * The prompts configuration for each supported model. One cannot have multiple prompts for the same model - this will return an invalid argument error.
   *
   * @generated from field: repeated gitpod.v1.RunnerSideAgentSpec.Prompts prompts = 1;
   */
  prompts: RunnerSideAgentSpec_Prompts[];

  /**
   * The list of tools required by this agent to function
   *
   * @generated from field: repeated string required_tools = 2;
   */
  requiredTools: string[];

  /**
   * Ordered list of models the runner should try when creating an LLM client.
   * Populated by the backend based on org tier. If empty, the runner falls
   * back to its built-in PreferredModels list (backward compatibility).
   *
   * @generated from field: repeated gitpod.v1.SupportedModel preferred_models = 3;
   */
  preferredModels: SupportedModel[];
};

/**
 * Describes the message gitpod.v1.RunnerSideAgentSpec.
 * Use `create(RunnerSideAgentSpecSchema)` to create a new message.
 */
export const RunnerSideAgentSpecSchema: GenMessage<RunnerSideAgentSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 30);

/**
 * @generated from message gitpod.v1.RunnerSideAgentSpec.Prompts
 */
export type RunnerSideAgentSpec_Prompts = Message<"gitpod.v1.RunnerSideAgentSpec.Prompts"> & {
  /**
   * The model these prompts are for
   *
   * @generated from field: gitpod.v1.SupportedModel model = 1;
   */
  model: SupportedModel;

  /**
   * The system prompt that defines the agent's role and capabilities
   *
   * @generated from field: string system_prompt = 2;
   */
  systemPrompt: string;

  /**
   * The initial message sent to the user. If empty, the agent will start in WAITING_FOR_INPUT state
   *
   * @generated from field: string initial_message = 3;
   */
  initialMessage: string;

  /**
   * The prompt used to evaluate agent's performance and provide final assessment
   *
   * @generated from field: string judgement_prompt = 4;
   */
  judgementPrompt: string;

  /**
   * The prompt used to improve the agent's prompt
   *
   * @generated from field: string improve_prompt = 5;
   */
  improvePrompt: string;
};

/**
 * Describes the message gitpod.v1.RunnerSideAgentSpec.Prompts.
 * Use `create(RunnerSideAgentSpec_PromptsSchema)` to create a new message.
 */
export const RunnerSideAgentSpec_PromptsSchema: GenMessage<RunnerSideAgentSpec_Prompts> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 30, 0);

/**
 * @generated from message gitpod.v1.InEnvironmentAgentSpec
 */
export type InEnvironmentAgentSpec = Message<"gitpod.v1.InEnvironmentAgentSpec"> & {
  /**
   * @generated from field: gitpod.v1.ServiceSpec service = 1;
   */
  service?: ServiceSpec;

  /**
   * The list of models supported by this in-environment agent
   *
   * @generated from field: repeated gitpod.v1.SupportedModel required_models = 2;
   */
  requiredModels: SupportedModel[];

  /**
   * service_metadata is optional metadata applied when creating the
   * automation service for this agent inside an environment.
   * Use this to set triggers (e.g. postDevcontainerStart) so the service
   * auto-starts on environment restart.
   *
   * @generated from field: gitpod.v1.ServiceMetadata service_metadata = 3;
   */
  serviceMetadata?: ServiceMetadata;
};

/**
 * Describes the message gitpod.v1.InEnvironmentAgentSpec.
 * Use `create(InEnvironmentAgentSpecSchema)` to create a new message.
 */
export const InEnvironmentAgentSpecSchema: GenMessage<InEnvironmentAgentSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 31);

/**
 * @generated from message gitpod.v1.CreateAgentRequest
 */
export type CreateAgentRequest = Message<"gitpod.v1.CreateAgentRequest"> & {
  /**
   * The name of the agent
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * A description of what the agent does
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from oneof gitpod.v1.CreateAgentRequest.spec
   */
  spec: {
    /**
     * @generated from field: gitpod.v1.RunnerSideAgentSpec runner_side = 10;
     */
    value: RunnerSideAgentSpec;
    case: "runnerSide";
  } | {
    /**
     * @generated from field: gitpod.v1.InEnvironmentAgentSpec in_environment = 20;
     */
    value: InEnvironmentAgentSpec;
    case: "inEnvironment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.CreateAgentRequest.
 * Use `create(CreateAgentRequestSchema)` to create a new message.
 */
export const CreateAgentRequestSchema: GenMessage<CreateAgentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 32);

/**
 * @generated from message gitpod.v1.CreateAgentResponse
 */
export type CreateAgentResponse = Message<"gitpod.v1.CreateAgentResponse"> & {
  /**
   * The created agent
   *
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message gitpod.v1.CreateAgentResponse.
 * Use `create(CreateAgentResponseSchema)` to create a new message.
 */
export const CreateAgentResponseSchema: GenMessage<CreateAgentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 33);

/**
 * @generated from message gitpod.v1.UpdateAgentRequest
 */
export type UpdateAgentRequest = Message<"gitpod.v1.UpdateAgentRequest"> & {
  /**
   * The ID of the agent to update
   *
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * Optional metadata which will replace the existing metadata partially
   * If not provided, the existing metadata will be kept.
   *
   * @generated from field: gitpod.v1.UpdateAgentRequest.Metadata metadata = 2;
   */
  metadata?: UpdateAgentRequest_Metadata;

  /**
   * Optional spec which will replace the existing spec partially
   *
   * @generated from field: gitpod.v1.UpdateAgentRequest.Spec spec = 3;
   */
  spec?: UpdateAgentRequest_Spec;
};

/**
 * Describes the message gitpod.v1.UpdateAgentRequest.
 * Use `create(UpdateAgentRequestSchema)` to create a new message.
 */
export const UpdateAgentRequestSchema: GenMessage<UpdateAgentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 34);

/**
 * @generated from message gitpod.v1.UpdateAgentRequest.Metadata
 */
export type UpdateAgentRequest_Metadata = Message<"gitpod.v1.UpdateAgentRequest.Metadata"> & {
  /**
   * The name of the agent
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * A description of what the agent does
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.UpdateAgentRequest.Metadata.
 * Use `create(UpdateAgentRequest_MetadataSchema)` to create a new message.
 */
export const UpdateAgentRequest_MetadataSchema: GenMessage<UpdateAgentRequest_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 34, 0);

/**
 * @generated from message gitpod.v1.UpdateAgentRequest.Spec
 */
export type UpdateAgentRequest_Spec = Message<"gitpod.v1.UpdateAgentRequest.Spec"> & {
  /**
   * The prompts configuration for each supported model.
   * Setting the system prompt of a model to the empty value will remove the system prompt for that model.
   * Adding a prompt for a model that already has a prompt will replace the existing prompt for that model.
   * Adding a prompt for a model that does not exist adds a new prompt for that model.
   *
   * @generated from field: repeated gitpod.v1.RunnerSideAgentSpec.Prompts prompts = 1;
   */
  prompts: RunnerSideAgentSpec_Prompts[];

  /**
   * The list of tools required by this agent to function.
   * Providing a value here will replace the existing list of required tools.
   *
   * @generated from field: repeated string required_tools = 2;
   */
  requiredTools: string[];
};

/**
 * Describes the message gitpod.v1.UpdateAgentRequest.Spec.
 * Use `create(UpdateAgentRequest_SpecSchema)` to create a new message.
 */
export const UpdateAgentRequest_SpecSchema: GenMessage<UpdateAgentRequest_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 34, 1);

/**
 * @generated from message gitpod.v1.UpdateAgentResponse
 */
export type UpdateAgentResponse = Message<"gitpod.v1.UpdateAgentResponse"> & {
  /**
   * The updated agent
   *
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;
};

/**
 * Describes the message gitpod.v1.UpdateAgentResponse.
 * Use `create(UpdateAgentResponseSchema)` to create a new message.
 */
export const UpdateAgentResponseSchema: GenMessage<UpdateAgentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 35);

/**
 * @generated from message gitpod.v1.DeleteAgentRequest
 */
export type DeleteAgentRequest = Message<"gitpod.v1.DeleteAgentRequest"> & {
  /**
   * The ID of the agent to delete
   *
   * @generated from field: string agent_id = 1;
   */
  agentId: string;
};

/**
 * Describes the message gitpod.v1.DeleteAgentRequest.
 * Use `create(DeleteAgentRequestSchema)` to create a new message.
 */
export const DeleteAgentRequestSchema: GenMessage<DeleteAgentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 36);

/**
 * @generated from message gitpod.v1.DeleteAgentResponse
 */
export type DeleteAgentResponse = Message<"gitpod.v1.DeleteAgentResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteAgentResponse.
 * Use `create(DeleteAgentResponseSchema)` to create a new message.
 */
export const DeleteAgentResponseSchema: GenMessage<DeleteAgentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 37);

/**
 * @generated from message gitpod.v1.StopAgentExecutionRequest
 */
export type StopAgentExecutionRequest = Message<"gitpod.v1.StopAgentExecutionRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.StopAgentExecutionRequest.
 * Use `create(StopAgentExecutionRequestSchema)` to create a new message.
 */
export const StopAgentExecutionRequestSchema: GenMessage<StopAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 38);

/**
 * @generated from message gitpod.v1.StopAgentExecutionResponse
 */
export type StopAgentExecutionResponse = Message<"gitpod.v1.StopAgentExecutionResponse"> & {
};

/**
 * Describes the message gitpod.v1.StopAgentExecutionResponse.
 * Use `create(StopAgentExecutionResponseSchema)` to create a new message.
 */
export const StopAgentExecutionResponseSchema: GenMessage<StopAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 39);

/**
 * @generated from message gitpod.v1.UpdateAgentExecutionRequest
 */
export type UpdateAgentExecutionRequest = Message<"gitpod.v1.UpdateAgentExecutionRequest"> & {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * Metadata updates. If not provided, existing metadata is kept.
   *
   * @generated from field: gitpod.v1.UpdateAgentExecutionRequest.Metadata metadata = 2;
   */
  metadata?: UpdateAgentExecutionRequest_Metadata;

  /**
   * Spec updates. If not provided, existing spec is kept.
   *
   * @generated from field: gitpod.v1.UpdateAgentExecutionRequest.Spec spec = 3;
   */
  spec?: UpdateAgentExecutionRequest_Spec;
};

/**
 * Describes the message gitpod.v1.UpdateAgentExecutionRequest.
 * Use `create(UpdateAgentExecutionRequestSchema)` to create a new message.
 */
export const UpdateAgentExecutionRequestSchema: GenMessage<UpdateAgentExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 40);

/**
 * @generated from message gitpod.v1.UpdateAgentExecutionRequest.Metadata
 */
export type UpdateAgentExecutionRequest_Metadata = Message<"gitpod.v1.UpdateAgentExecutionRequest.Metadata"> & {
  /**
   * annotations are key-value pairs for tracking external context.
   * Keys with the "gitpod.io/" prefix are reserved and cannot be set through this API.
   * Provided annotations are merged with existing annotations.
   *
   * @generated from field: map<string, string> annotations = 2;
   */
  annotations: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.UpdateAgentExecutionRequest.Metadata.
 * Use `create(UpdateAgentExecutionRequest_MetadataSchema)` to create a new message.
 */
export const UpdateAgentExecutionRequest_MetadataSchema: GenMessage<UpdateAgentExecutionRequest_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 40, 0);

/**
 * @generated from message gitpod.v1.UpdateAgentExecutionRequest.Spec
 */
export type UpdateAgentExecutionRequest_Spec = Message<"gitpod.v1.UpdateAgentExecutionRequest.Spec"> & {
  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Spec.LoopCondition loop_conditions = 1;
   */
  loopConditions: AgentExecution_Spec_LoopCondition[];
};

/**
 * Describes the message gitpod.v1.UpdateAgentExecutionRequest.Spec.
 * Use `create(UpdateAgentExecutionRequest_SpecSchema)` to create a new message.
 */
export const UpdateAgentExecutionRequest_SpecSchema: GenMessage<UpdateAgentExecutionRequest_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 40, 1);

/**
 * @generated from message gitpod.v1.UpdateAgentExecutionResponse
 */
export type UpdateAgentExecutionResponse = Message<"gitpod.v1.UpdateAgentExecutionResponse"> & {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;
};

/**
 * Describes the message gitpod.v1.UpdateAgentExecutionResponse.
 * Use `create(UpdateAgentExecutionResponseSchema)` to create a new message.
 */
export const UpdateAgentExecutionResponseSchema: GenMessage<UpdateAgentExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 41);

/**
 * @generated from message gitpod.v1.ReportAgentExecutionOutputsRequest
 */
export type ReportAgentExecutionOutputsRequest = Message<"gitpod.v1.ReportAgentExecutionOutputsRequest"> & {
  /**
   * The ID of the agent execution to report outputs for
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * Outputs to report. New outputs are merged with existing outputs.
   * Values are stored as strings and the API determines the type.
   *
   * @generated from field: map<string, gitpod.v1.AgentExecution.Status.OutputValue> outputs = 2;
   */
  outputs: { [key: string]: AgentExecution_Status_OutputValue };
};

/**
 * Describes the message gitpod.v1.ReportAgentExecutionOutputsRequest.
 * Use `create(ReportAgentExecutionOutputsRequestSchema)` to create a new message.
 */
export const ReportAgentExecutionOutputsRequestSchema: GenMessage<ReportAgentExecutionOutputsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 42);

/**
 * @generated from message gitpod.v1.ReportAgentExecutionOutputsResponse
 */
export type ReportAgentExecutionOutputsResponse = Message<"gitpod.v1.ReportAgentExecutionOutputsResponse"> & {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;
};

/**
 * Describes the message gitpod.v1.ReportAgentExecutionOutputsResponse.
 * Use `create(ReportAgentExecutionOutputsResponseSchema)` to create a new message.
 */
export const ReportAgentExecutionOutputsResponseSchema: GenMessage<ReportAgentExecutionOutputsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 43);

/**
 * @generated from message gitpod.v1.EmitAgentSessionActivityRequest
 */
export type EmitAgentSessionActivityRequest = Message<"gitpod.v1.EmitAgentSessionActivityRequest"> & {
  /**
   * The agent execution ID. Used to resolve the organization for auth/token lookup.
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * The external session ID (e.g., Linear agent session ID).
   * The runner resolves this from annotations at startup and passes it directly,
   * avoiding repeated annotation lookups on every emit call.
   *
   * @generated from field: string external_agent_session_id = 2;
   */
  externalAgentSessionId: string;

  /**
   * The structured response block to forward to the external session.
   * The backend type-switches on the block's oneof output to decide how to render.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock response_block = 3;
   */
  responseBlock?: AgentResponseBlock;

  /**
   * The current agent execution status. When present, the backend uses this
   * for phase-specific emissions (thoughts, errors, keepalive, external URLs)
   * instead of relying on the separate status reflection path.
   * This field is optional for backward compatibility.
   *
   * @generated from field: gitpod.v1.AgentExecution.Status status = 4;
   */
  status?: AgentExecution_Status;

  /**
   * Optional next steps proposal from the agent. Reported separately from
   * response_block so integrations can decide whether and how to render it.
   * The Linear integration ignores this; other integrations may render it.
   *
   * @generated from field: gitpod.v1.NextStepsProposal next_steps_proposal = 5;
   */
  nextStepsProposal?: NextStepsProposal;
};

/**
 * Describes the message gitpod.v1.EmitAgentSessionActivityRequest.
 * Use `create(EmitAgentSessionActivityRequestSchema)` to create a new message.
 */
export const EmitAgentSessionActivityRequestSchema: GenMessage<EmitAgentSessionActivityRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 44);

/**
 * @generated from message gitpod.v1.EmitAgentSessionActivityResponse
 */
export type EmitAgentSessionActivityResponse = Message<"gitpod.v1.EmitAgentSessionActivityResponse"> & {
};

/**
 * Describes the message gitpod.v1.EmitAgentSessionActivityResponse.
 * Use `create(EmitAgentSessionActivityResponseSchema)` to create a new message.
 */
export const EmitAgentSessionActivityResponseSchema: GenMessage<EmitAgentSessionActivityResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 45);

/**
 * @generated from message gitpod.v1.ImprovePromptForAgentRequest
 */
export type ImprovePromptForAgentRequest = Message<"gitpod.v1.ImprovePromptForAgentRequest"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;
};

/**
 * Describes the message gitpod.v1.ImprovePromptForAgentRequest.
 * Use `create(ImprovePromptForAgentRequestSchema)` to create a new message.
 */
export const ImprovePromptForAgentRequestSchema: GenMessage<ImprovePromptForAgentRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 46);

/**
 * @generated from message gitpod.v1.ImprovePromptForAgentResponse
 */
export type ImprovePromptForAgentResponse = Message<"gitpod.v1.ImprovePromptForAgentResponse"> & {
  /**
   * @generated from field: string improved_prompt = 1;
   */
  improvedPrompt: string;
};

/**
 * Describes the message gitpod.v1.ImprovePromptForAgentResponse.
 * Use `create(ImprovePromptForAgentResponseSchema)` to create a new message.
 */
export const ImprovePromptForAgentResponseSchema: GenMessage<ImprovePromptForAgentResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 47);

/**
 * @generated from message gitpod.v1.CreateLLMAccessTokenRequest
 */
export type CreateLLMAccessTokenRequest = Message<"gitpod.v1.CreateLLMAccessTokenRequest"> & {
  /**
   * The models required by the agent to function.
   *
   * @generated from field: repeated gitpod.v1.SupportedModel required_models = 1;
   */
  requiredModels: SupportedModel[];

  /**
   * The agent execution ID for tracking and runner selection.
   * If empty, falls back to current logic for backward compatibility.
   *
   * @generated from field: string agent_execution_id = 3;
   */
  agentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.CreateLLMAccessTokenRequest.
 * Use `create(CreateLLMAccessTokenRequestSchema)` to create a new message.
 */
export const CreateLLMAccessTokenRequestSchema: GenMessage<CreateLLMAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 48);

/**
 * @generated from message gitpod.v1.CreateLLMAccessTokenResponse
 */
export type CreateLLMAccessTokenResponse = Message<"gitpod.v1.CreateLLMAccessTokenResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string llm_url = 2;
   */
  llmUrl: string;

  /**
   * is_server_side_tool_search_enabled indicates whether the LLM provider
   * supports Anthropic's server-side BM25 tool search. Computed by the
   * management plane based on the provider type and feature flags.
   *
   * @generated from field: bool is_server_side_tool_search_enabled = 3;
   */
  isServerSideToolSearchEnabled: boolean;
};

/**
 * Describes the message gitpod.v1.CreateLLMAccessTokenResponse.
 * Use `create(CreateLLMAccessTokenResponseSchema)` to create a new message.
 */
export const CreateLLMAccessTokenResponseSchema: GenMessage<CreateLLMAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 49);

/**
 * @generated from message gitpod.v1.MCPIntegration
 */
export type MCPIntegration = Message<"gitpod.v1.MCPIntegration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * Whether the calling user has authenticated with this integration
   * (i.e. has a host authentication token for it).
   *
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message gitpod.v1.MCPIntegration.
 * Use `create(MCPIntegrationSchema)` to create a new message.
 */
export const MCPIntegrationSchema: GenMessage<MCPIntegration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 50);

/**
 * @generated from message gitpod.v1.ListMCPIntegrationsRequest
 */
export type ListMCPIntegrationsRequest = Message<"gitpod.v1.ListMCPIntegrationsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListMCPIntegrationsRequest.
 * Use `create(ListMCPIntegrationsRequestSchema)` to create a new message.
 */
export const ListMCPIntegrationsRequestSchema: GenMessage<ListMCPIntegrationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 51);

/**
 * @generated from message gitpod.v1.ListMCPIntegrationsResponse
 */
export type ListMCPIntegrationsResponse = Message<"gitpod.v1.ListMCPIntegrationsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.MCPIntegration mcp_integrations = 2;
   */
  mcpIntegrations: MCPIntegration[];
};

/**
 * Describes the message gitpod.v1.ListMCPIntegrationsResponse.
 * Use `create(ListMCPIntegrationsResponseSchema)` to create a new message.
 */
export const ListMCPIntegrationsResponseSchema: GenMessage<ListMCPIntegrationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 52);

/**
 * @generated from message gitpod.v1.CreateMCPAccessTokenRequest
 */
export type CreateMCPAccessTokenRequest = Message<"gitpod.v1.CreateMCPAccessTokenRequest"> & {
};

/**
 * Describes the message gitpod.v1.CreateMCPAccessTokenRequest.
 * Use `create(CreateMCPAccessTokenRequestSchema)` to create a new message.
 */
export const CreateMCPAccessTokenRequestSchema: GenMessage<CreateMCPAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 53);

/**
 * @generated from message gitpod.v1.CreateMCPAccessTokenResponse
 */
export type CreateMCPAccessTokenResponse = Message<"gitpod.v1.CreateMCPAccessTokenResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreateMCPAccessTokenResponse.
 * Use `create(CreateMCPAccessTokenResponseSchema)` to create a new message.
 */
export const CreateMCPAccessTokenResponseSchema: GenMessage<CreateMCPAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 54);

/**
 * @generated from message gitpod.v1.CreateSearchAccessTokenRequest
 */
export type CreateSearchAccessTokenRequest = Message<"gitpod.v1.CreateSearchAccessTokenRequest"> & {
};

/**
 * Describes the message gitpod.v1.CreateSearchAccessTokenRequest.
 * Use `create(CreateSearchAccessTokenRequestSchema)` to create a new message.
 */
export const CreateSearchAccessTokenRequestSchema: GenMessage<CreateSearchAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 55);

/**
 * @generated from message gitpod.v1.CreateSearchAccessTokenResponse
 */
export type CreateSearchAccessTokenResponse = Message<"gitpod.v1.CreateSearchAccessTokenResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreateSearchAccessTokenResponse.
 * Use `create(CreateSearchAccessTokenResponseSchema)` to create a new message.
 */
export const CreateSearchAccessTokenResponseSchema: GenMessage<CreateSearchAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 56);

/**
 * @generated from message gitpod.v1.Prompt
 */
export type Prompt = Message<"gitpod.v1.Prompt"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.PromptMetadata metadata = 2;
   */
  metadata?: PromptMetadata;

  /**
   * @generated from field: gitpod.v1.PromptSpec spec = 3;
   */
  spec?: PromptSpec;
};

/**
 * Describes the message gitpod.v1.Prompt.
 * Use `create(PromptSchema)` to create a new message.
 */
export const PromptSchema: GenMessage<Prompt> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 57);

/**
 * @generated from message gitpod.v1.PromptMetadata
 */
export type PromptMetadata = Message<"gitpod.v1.PromptMetadata"> & {
  /**
   * organization_id is the ID of the organization that contains the prompt
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * name is the human readable name of the prompt
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * description is a description of what the prompt does
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * creator is the identity of the prompt creator
   *
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.PromptMetadata.
 * Use `create(PromptMetadataSchema)` to create a new message.
 */
export const PromptMetadataSchema: GenMessage<PromptMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 58);

/**
 * @generated from message gitpod.v1.PromptSpec
 */
export type PromptSpec = Message<"gitpod.v1.PromptSpec"> & {
  /**
   * prompt is the content of the prompt
   *
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * is_template indicates if this prompt is a template
   *
   * @generated from field: bool is_template = 2;
   */
  isTemplate: boolean;

  /**
   * is_command indicates if this prompt is a command
   *
   * @generated from field: bool is_command = 3;
   */
  isCommand: boolean;

  /**
   * command is the unique command string within the organization
   *
   * @generated from field: string command = 4;
   */
  command: string;

  /**
   * is_skill indicates if this prompt is a skill (workflow instructions for agents)
   *
   * @generated from field: bool is_skill = 5;
   */
  isSkill: boolean;
};

/**
 * Describes the message gitpod.v1.PromptSpec.
 * Use `create(PromptSpecSchema)` to create a new message.
 */
export const PromptSpecSchema: GenMessage<PromptSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 59);

/**
 * @generated from message gitpod.v1.ListPromptsRequest
 */
export type ListPromptsRequest = Message<"gitpod.v1.ListPromptsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListPromptsRequest.Filter filter = 2;
   */
  filter?: ListPromptsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListPromptsRequest.
 * Use `create(ListPromptsRequestSchema)` to create a new message.
 */
export const ListPromptsRequestSchema: GenMessage<ListPromptsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 60);

/**
 * @generated from message gitpod.v1.ListPromptsRequest.Filter
 */
export type ListPromptsRequest_Filter = Message<"gitpod.v1.ListPromptsRequest.Filter"> & {
  /**
   * @generated from field: bool is_template = 1;
   */
  isTemplate: boolean;

  /**
   * @generated from field: bool is_command = 2;
   */
  isCommand: boolean;

  /**
   * @generated from field: string command = 3;
   */
  command: string;

  /**
   * @generated from field: string command_prefix = 4;
   */
  commandPrefix: string;

  /**
   * @generated from field: bool is_skill = 5;
   */
  isSkill: boolean;

  /**
   * exclude_prompt_content omits the large spec.prompt text from the response.
   * Other spec fields (is_template, is_command, command, is_skill) are still returned.
   * Use GetPrompt to retrieve the full prompt content when needed.
   *
   * @generated from field: bool exclude_prompt_content = 6;
   */
  excludePromptContent: boolean;

  /**
   * search performs case-insensitive search across prompt name, description, and command.
   *
   * @generated from field: string search = 7;
   */
  search: string;
};

/**
 * Describes the message gitpod.v1.ListPromptsRequest.Filter.
 * Use `create(ListPromptsRequest_FilterSchema)` to create a new message.
 */
export const ListPromptsRequest_FilterSchema: GenMessage<ListPromptsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 60, 0);

/**
 * @generated from message gitpod.v1.ListPromptsResponse
 */
export type ListPromptsResponse = Message<"gitpod.v1.ListPromptsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Prompt prompts = 2;
   */
  prompts: Prompt[];
};

/**
 * Describes the message gitpod.v1.ListPromptsResponse.
 * Use `create(ListPromptsResponseSchema)` to create a new message.
 */
export const ListPromptsResponseSchema: GenMessage<ListPromptsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 61);

/**
 * @generated from message gitpod.v1.GetPromptRequest
 */
export type GetPromptRequest = Message<"gitpod.v1.GetPromptRequest"> & {
  /**
   * @generated from field: string prompt_id = 1;
   */
  promptId: string;
};

/**
 * Describes the message gitpod.v1.GetPromptRequest.
 * Use `create(GetPromptRequestSchema)` to create a new message.
 */
export const GetPromptRequestSchema: GenMessage<GetPromptRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 62);

/**
 * @generated from message gitpod.v1.GetPromptResponse
 */
export type GetPromptResponse = Message<"gitpod.v1.GetPromptResponse"> & {
  /**
   * @generated from field: gitpod.v1.Prompt prompt = 1;
   */
  prompt?: Prompt;
};

/**
 * Describes the message gitpod.v1.GetPromptResponse.
 * Use `create(GetPromptResponseSchema)` to create a new message.
 */
export const GetPromptResponseSchema: GenMessage<GetPromptResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 63);

/**
 * @generated from message gitpod.v1.CreatePromptRequest
 */
export type CreatePromptRequest = Message<"gitpod.v1.CreatePromptRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string prompt = 3;
   */
  prompt: string;

  /**
   * @generated from field: bool is_template = 4;
   */
  isTemplate: boolean;

  /**
   * @generated from field: bool is_command = 5;
   */
  isCommand: boolean;

  /**
   * @generated from field: string command = 6;
   */
  command: string;

  /**
   * @generated from field: bool is_skill = 7;
   */
  isSkill: boolean;
};

/**
 * Describes the message gitpod.v1.CreatePromptRequest.
 * Use `create(CreatePromptRequestSchema)` to create a new message.
 */
export const CreatePromptRequestSchema: GenMessage<CreatePromptRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 64);

/**
 * @generated from message gitpod.v1.CreatePromptResponse
 */
export type CreatePromptResponse = Message<"gitpod.v1.CreatePromptResponse"> & {
  /**
   * @generated from field: gitpod.v1.Prompt prompt = 1;
   */
  prompt?: Prompt;
};

/**
 * Describes the message gitpod.v1.CreatePromptResponse.
 * Use `create(CreatePromptResponseSchema)` to create a new message.
 */
export const CreatePromptResponseSchema: GenMessage<CreatePromptResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 65);

/**
 * @generated from message gitpod.v1.UpdatePromptRequest
 */
export type UpdatePromptRequest = Message<"gitpod.v1.UpdatePromptRequest"> & {
  /**
   * The ID of the prompt to update
   *
   * @generated from field: string prompt_id = 1;
   */
  promptId: string;

  /**
   * Metadata updates
   *
   * @generated from field: optional gitpod.v1.UpdatePromptRequest.Metadata metadata = 2;
   */
  metadata?: UpdatePromptRequest_Metadata;

  /**
   * Spec updates
   *
   * @generated from field: optional gitpod.v1.UpdatePromptRequest.Spec spec = 3;
   */
  spec?: UpdatePromptRequest_Spec;
};

/**
 * Describes the message gitpod.v1.UpdatePromptRequest.
 * Use `create(UpdatePromptRequestSchema)` to create a new message.
 */
export const UpdatePromptRequestSchema: GenMessage<UpdatePromptRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 66);

/**
 * @generated from message gitpod.v1.UpdatePromptRequest.Metadata
 */
export type UpdatePromptRequest_Metadata = Message<"gitpod.v1.UpdatePromptRequest.Metadata"> & {
  /**
   * The name of the prompt
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * A description of what the prompt does
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.UpdatePromptRequest.Metadata.
 * Use `create(UpdatePromptRequest_MetadataSchema)` to create a new message.
 */
export const UpdatePromptRequest_MetadataSchema: GenMessage<UpdatePromptRequest_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 66, 0);

/**
 * @generated from message gitpod.v1.UpdatePromptRequest.Spec
 */
export type UpdatePromptRequest_Spec = Message<"gitpod.v1.UpdatePromptRequest.Spec"> & {
  /**
   * The prompt content
   *
   * @generated from field: optional string prompt = 1;
   */
  prompt?: string;

  /**
   * Whether this prompt is a template
   *
   * @generated from field: optional bool is_template = 2;
   */
  isTemplate?: boolean;

  /**
   * Whether this prompt is a command
   *
   * @generated from field: optional bool is_command = 3;
   */
  isCommand?: boolean;

  /**
   * The command string (unique within organization)
   *
   * @generated from field: optional string command = 4;
   */
  command?: string;

  /**
   * Whether this prompt is a skill
   *
   * @generated from field: optional bool is_skill = 5;
   */
  isSkill?: boolean;
};

/**
 * Describes the message gitpod.v1.UpdatePromptRequest.Spec.
 * Use `create(UpdatePromptRequest_SpecSchema)` to create a new message.
 */
export const UpdatePromptRequest_SpecSchema: GenMessage<UpdatePromptRequest_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 66, 1);

/**
 * @generated from message gitpod.v1.UpdatePromptResponse
 */
export type UpdatePromptResponse = Message<"gitpod.v1.UpdatePromptResponse"> & {
  /**
   * @generated from field: gitpod.v1.Prompt prompt = 1;
   */
  prompt?: Prompt;
};

/**
 * Describes the message gitpod.v1.UpdatePromptResponse.
 * Use `create(UpdatePromptResponseSchema)` to create a new message.
 */
export const UpdatePromptResponseSchema: GenMessage<UpdatePromptResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 67);

/**
 * @generated from message gitpod.v1.DeletePromptRequest
 */
export type DeletePromptRequest = Message<"gitpod.v1.DeletePromptRequest"> & {
  /**
   * @generated from field: string prompt_id = 1;
   */
  promptId: string;
};

/**
 * Describes the message gitpod.v1.DeletePromptRequest.
 * Use `create(DeletePromptRequestSchema)` to create a new message.
 */
export const DeletePromptRequestSchema: GenMessage<DeletePromptRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 68);

/**
 * @generated from message gitpod.v1.DeletePromptResponse
 */
export type DeletePromptResponse = Message<"gitpod.v1.DeletePromptResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeletePromptResponse.
 * Use `create(DeletePromptResponseSchema)` to create a new message.
 */
export const DeletePromptResponseSchema: GenMessage<DeletePromptResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_agent, 69);

/**
 * AgentMode defines the operational mode of an agent
 *
 * @generated from enum gitpod.v1.AgentMode
 */
export enum AgentMode {
  /**
   * Default execution mode - standard agent behavior
   *
   * @generated from enum value: AGENT_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Execution mode - agent performs tasks and makes changes
   *
   * @generated from enum value: AGENT_MODE_EXECUTION = 1;
   */
  EXECUTION = 1,

  /**
   * Planning mode - agent focuses on analysis and planning
   *
   * @generated from enum value: AGENT_MODE_PLANNING = 2;
   */
  PLANNING = 2,

  /**
   * Ralph mode - autonomous planning and implementation mode
   *
   * @generated from enum value: AGENT_MODE_RALPH = 3;
   */
  RALPH = 3,

  /**
   * Spec mode - planning phase followed by interactive implementation
   *
   * @generated from enum value: AGENT_MODE_SPEC = 4;
   */
  SPEC = 4,
}

/**
 * Describes the enum gitpod.v1.AgentMode.
 */
export const AgentModeSchema: GenEnum<AgentMode> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 0);

/**
 * @generated from enum gitpod.v1.SupportedModel
 */
export enum SupportedModel {
  /**
   * @generated from enum value: SUPPORTED_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_5 = 1;
   */
  SONNET_3_5 = 1,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_7 = 2;
   */
  SONNET_3_7 = 2,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_7_EXTENDED = 3;
   */
  SONNET_3_7_EXTENDED = 3,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4 = 4;
   */
  SONNET_4 = 4,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_EXTENDED = 5;
   */
  SONNET_4_EXTENDED = 5,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_5 = 8;
   */
  SONNET_4_5 = 8,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_5_EXTENDED = 9;
   */
  SONNET_4_5_EXTENDED = 9,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_6 = 18;
   */
  SONNET_4_6 = 18,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_6_EXTENDED = 19;
   */
  SONNET_4_6_EXTENDED = 19,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4 = 6;
   */
  OPUS_4 = 6,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_EXTENDED = 7;
   */
  OPUS_4_EXTENDED = 7,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_5 = 14;
   */
  OPUS_4_5 = 14,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_5_EXTENDED = 15;
   */
  OPUS_4_5_EXTENDED = 15,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_6 = 16;
   */
  OPUS_4_6 = 16,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_6_EXTENDED = 17;
   */
  OPUS_4_6_EXTENDED = 17,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_7 = 22;
   */
  OPUS_4_7 = 22,

  /**
   * @generated from enum value: SUPPORTED_MODEL_HAIKU_4_5 = 21;
   */
  HAIKU_4_5 = 21,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_4O = 10;
   */
  OPENAI_4O = 10,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_4O_MINI = 11;
   */
  OPENAI_4O_MINI = 11,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_O1 = 12;
   */
  OPENAI_O1 = 12,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_O1_MINI = 13;
   */
  OPENAI_O1_MINI = 13,
}

/**
 * Describes the enum gitpod.v1.SupportedModel.
 */
export const SupportedModelSchema: GenEnum<SupportedModel> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 1);

/**
 * LLMIntegrationPhase represents the current status/phase of an LLM integration
 *
 * @generated from enum gitpod.v1.LLMIntegrationPhase
 */
export enum LLMIntegrationPhase {
  /**
   * @generated from enum value: LLM_INTEGRATION_PHASE_UNSPECIFIED = 0;
   */
  LLM_INTEGRATION_PHASE_UNSPECIFIED = 0,

  /**
   * The integration can be used to make requests
   *
   * @generated from enum value: LLM_INTEGRATION_PHASE_AVAILABLE = 1;
   */
  LLM_INTEGRATION_PHASE_AVAILABLE = 1,

  /**
   * The integration cannot be used, likely due to insufficient funds
   *
   * @generated from enum value: LLM_INTEGRATION_PHASE_UNAVAILABLE = 2;
   */
  LLM_INTEGRATION_PHASE_UNAVAILABLE = 2,

  /**
   * The integration cannot be used because the user disabled it
   *
   * @generated from enum value: LLM_INTEGRATION_PHASE_DISABLED = 3;
   */
  LLM_INTEGRATION_PHASE_DISABLED = 3,
}

/**
 * Describes the enum gitpod.v1.LLMIntegrationPhase.
 */
export const LLMIntegrationPhaseSchema: GenEnum<LLMIntegrationPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 2);

/**
 * AgentExecutionFailureReason represents the reason why an agent execution failed
 *
 * @generated from enum gitpod.v1.AgentExecutionFailureReason
 */
export enum AgentExecutionFailureReason {
  /**
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The agent execution failed due to environment issues
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * The agent execution failed due to service issues
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_SERVICE = 2;
   */
  SERVICE = 2,

  /**
   * The agent execution failed due to LLM integration issues
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_LLM_INTEGRATION = 3;
   */
  LLM_INTEGRATION = 3,

  /**
   * Deprecated: The agent execution failed due to internal errors
   * Use AGENT_EXECUTION_FAILURE_REASON_AGENT_EXECUTION instead
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_INTERNAL = 4;
   */
  INTERNAL = 4,

  /**
   * The agent execution failed due to agent execution errors
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_AGENT_EXECUTION = 5;
   */
  AGENT_EXECUTION = 5,
}

/**
 * Describes the enum gitpod.v1.AgentExecutionFailureReason.
 */
export const AgentExecutionFailureReasonSchema: GenEnum<AgentExecutionFailureReason> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 3);

/**
 * AgentExecutionRole represents the role of an agent execution
 *
 * @generated from enum gitpod.v1.AgentExecutionRole
 */
export enum AgentExecutionRole {
  /**
   * @generated from enum value: AGENT_EXECUTION_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Default role for agent executions
   *
   * @generated from enum value: AGENT_EXECUTION_ROLE_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * Workflow role for agent executions that are part of a workflow
   *
   * @generated from enum value: AGENT_EXECUTION_ROLE_WORKFLOW = 2;
   */
  WORKFLOW = 2,
}

/**
 * Describes the enum gitpod.v1.AgentExecutionRole.
 */
export const AgentExecutionRoleSchema: GenEnum<AgentExecutionRole> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 4);

/**
 * MCPIntegrationPhase represents the status of an MCP integration connection
 *
 * @generated from enum gitpod.v1.MCPIntegrationPhase
 */
export enum MCPIntegrationPhase {
  /**
   * @generated from enum value: MCP_INTEGRATION_PHASE_UNSPECIFIED = 0;
   */
  MCP_INTEGRATION_PHASE_UNSPECIFIED = 0,

  /**
   * The MCP integration is initializing connection
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_INITIALIZING = 10;
   */
  MCP_INTEGRATION_PHASE_INITIALIZING = 10,

  /**
   * The MCP integration is connected and operational
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_READY = 20;
   */
  MCP_INTEGRATION_PHASE_READY = 20,

  /**
   * The MCP integration has failed and requires intervention
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_FAILED = 30;
   */
  MCP_INTEGRATION_PHASE_FAILED = 30,

  /**
   * The MCP integration is unavailable (server down, network issue)
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_UNAVAILABLE = 40;
   */
  MCP_INTEGRATION_PHASE_UNAVAILABLE = 40,
}

/**
 * Describes the enum gitpod.v1.MCPIntegrationPhase.
 */
export const MCPIntegrationPhaseSchema: GenEnum<MCPIntegrationPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_agent, 5);

/**
 * @generated from service gitpod.v1.AgentService
 */
export const AgentService: GenService<{
  /**
   * Lists all agents matching the specified criteria.
   *
   * Use this method to find and monitor agents across your organization.
   * Results are ordered by their creation time with the newest first.
   *
   * ### Examples
   *
   * - List all agents:
   *
   *   Retrieves all agents with pagination.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 10
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.ListAgents
   */
  listAgents: {
    methodKind: "unary";
    input: typeof ListAgentsRequestSchema;
    output: typeof ListAgentsResponseSchema;
  },
  /**
   * Gets details about a specific agent including description,
   * and required models.
   *
   * Use this method to:
   * - Check if an agent is defined correctly
   * - Understand which models are required for this agent
   *
   * ### Examples
   *
   * - Get agent details:
   *
   *   ```yaml
   *   agentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.GetAgent
   */
  getAgent: {
    methodKind: "unary";
    input: typeof GetAgentRequestSchema;
    output: typeof GetAgentResponseSchema;
  },
  /**
   * Creates a new agent.
   *
   * Use this method to:
   * - Define new agents with custom prompts and tools
   *
   * @generated from rpc gitpod.v1.AgentService.CreateAgent
   */
  createAgent: {
    methodKind: "unary";
    input: typeof CreateAgentRequestSchema;
    output: typeof CreateAgentResponseSchema;
  },
  /**
   * Updates an existing agent.
   *
   * Use this method to:
   * - Modify agent configuration
   * - Update prompts or required tools
   *
   * @generated from rpc gitpod.v1.AgentService.UpdateAgent
   */
  updateAgent: {
    methodKind: "unary";
    input: typeof UpdateAgentRequestSchema;
    output: typeof UpdateAgentResponseSchema;
  },
  /**
   * Deletes an agent.
   *
   * Use this method to:
   * - Remove custom agents
   *
   * @generated from rpc gitpod.v1.AgentService.DeleteAgent
   */
  deleteAgent: {
    methodKind: "unary";
    input: typeof DeleteAgentRequestSchema;
    output: typeof DeleteAgentResponseSchema;
  },
  /**
   * Starts (or triggers) an agent run using a provided agent.
   *
   * Use this method to:
   * - Launch an agent based on a known agent
   *
   * ### Examples
   *
   * - Start an agent with a project ID:
   *
   *   ```yaml
   *   agentId: "b8a64cfa-43e2-4b9d-9fb3-07edc63f5971"
   *   codeContext:
   *     projectId: "2d22e4eb-31da-467f-882c-27e21550992f"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.StartAgent
   */
  startAgent: {
    methodKind: "unary";
    input: typeof StartAgentRequestSchema;
    output: typeof StartAgentResponseSchema;
  },
  /**
   * Lists all agent runs matching the specified filter.
   *
   * Use this method to track multiple agent runs and their associated resources. Results are ordered by their creation time with the newest first.
   *
   * ### Examples
   *
   * - List agent runs by agent ID:
   *
   *   ```yaml
   *   filter:
   *     agentIds: ["b8a64cfa-43e2-4b9d-9fb3-07edc63f5971"]
   *   pagination:
   *     pageSize: 10
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.ListAgentExecutions
   */
  listAgentExecutions: {
    methodKind: "unary";
    input: typeof ListAgentExecutionsRequestSchema;
    output: typeof ListAgentExecutionsResponseSchema;
  },
  /**
   * Gets details about a specific agent run, including its metadata, specification,
   * and status (phase, error messages, and usage statistics).
   *
   * Use this method to:
   * - Monitor the run's progress
   * - Retrieve the agent's conversation URL
   * - Check if an agent run is actively producing output
   *
   * ### Examples
   *
   * - Get agent run details by ID:
   *
   *   ```yaml
   *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.GetAgentExecution
   */
  getAgentExecution: {
    methodKind: "unary";
    input: typeof GetAgentExecutionRequestSchema;
    output: typeof GetAgentExecutionResponseSchema;
  },
  /**
   * Deletes an agent run.
   *
   * Use this method to:
   * - Clean up agent runs that are no longer needed
   *
   * ### Examples
   *
   * - Delete an agent run by ID:
   *
   *   ```yaml
   *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.DeleteAgentExecution
   */
  deleteAgentExecution: {
    methodKind: "unary";
    input: typeof DeleteAgentExecutionRequestSchema;
    output: typeof DeleteAgentExecutionResponseSchema;
  },
  /**
   * Sends user input to an active agent run.
   *
   * This method is used to provide interactive or conversation-based input
   * to an agent. The agent can respond with output blocks containing
   * text, file changes, or tool usage requests.
   *
   * ### Examples
   *
   * - Send a text message to an agent:
   *
   *   ```yaml
   *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
   *   userInput:
   *     text:
   *       content: "Generate a report based on the latest logs."
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.SendToAgentExecution
   */
  sendToAgentExecution: {
    methodKind: "unary";
    input: typeof SendToAgentExecutionRequestSchema;
    output: typeof SendToAgentExecutionResponseSchema;
  },
  /**
   * Creates a token for conversation access with a specific agent run.
   *
   * This method generates a temporary token that can be used to securely
   * connect to an ongoing agent conversation, for example in a web UI.
   *
   * ### Examples
   *
   * - Create a token to join an agent run conversation in a front-end application:
   *
   *   ```yaml
   *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.CreateAgentExecutionConversationToken
   */
  createAgentExecutionConversationToken: {
    methodKind: "unary";
    input: typeof CreateAgentExecutionConversationTokenRequestSchema;
    output: typeof CreateAgentExecutionConversationTokenResponseSchema;
  },
  /**
   * Stops an active agent execution.
   *
   * Use this method to:
   * - Stop an agent that is currently running
   * - Prevent further processing or resource usage
   *
   * ### Examples
   *
   * - Stop an agent execution by ID:
   *
   *   ```yaml
   *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.StopAgentExecution
   */
  stopAgentExecution: {
    methodKind: "unary";
    input: typeof StopAgentExecutionRequestSchema;
    output: typeof StopAgentExecutionResponseSchema;
  },
  /**
   * Updates an agent execution's spec.
   *
   * Use this method to:
   * - Set or update loop conditions on an agent execution
   *
   * @generated from rpc gitpod.v1.AgentService.UpdateAgentExecution
   */
  updateAgentExecution: {
    methodKind: "unary";
    input: typeof UpdateAgentExecutionRequestSchema;
    output: typeof UpdateAgentExecutionResponseSchema;
  },
  /**
   * Reports outputs for an agent execution.
   *
   * This method allows agents to report key-value outputs during execution.
   * Similar to task execution outputs, but with typed values for structured data.
   * Outputs are merged with any existing outputs. The API automatically infers
   * the type (int, float, bool, or string) from the value.
   *
   * Use this method to:
   * - Record execution outcomes and metrics
   * - Track test results, coverage, or success indicators
   * - Store any execution-related data as key-value pairs
   *
   * Type inference rules:
   * - "true" or "false" → bool
   * - Valid integer (e.g., "42", "-10") → int
   * - Valid float (e.g., "85.5", "3.14") → float
   * - Everything else → string
   *
   * Validation limits (matching task execution outputs):
   * - Keys: 1-128 characters
   * - String values: max 4096 characters
   *
   * ### Examples
   *
   * - Report execution outputs (types will be inferred from string_value):
   *
   *   ```yaml
   *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
   *   outputs:
   *     tests_passed:
   *       stringValue: "42"        # inferred as int
   *     coverage:
   *       stringValue: "85.5"      # inferred as float
   *     success:
   *       stringValue: "true"      # inferred as bool
   *     message:
   *       stringValue: "All tests passed"  # stored as string
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.ReportAgentExecutionOutputs
   */
  reportAgentExecutionOutputs: {
    methodKind: "unary";
    input: typeof ReportAgentExecutionOutputsRequestSchema;
    output: typeof ReportAgentExecutionOutputsResponseSchema;
  },
  /**
   * Emits an activity to the external agent session (e.g., Linear) associated
   * with this agent execution. The backend resolves the session ID from the
   * execution's annotations and uses the org's app token to authenticate.
   *
   * @generated from rpc gitpod.v1.AgentService.EmitAgentSessionActivity
   */
  emitAgentSessionActivity: {
    methodKind: "unary";
    input: typeof EmitAgentSessionActivityRequestSchema;
    output: typeof EmitAgentSessionActivityResponseSchema;
  },
  /**
   * Improves an agent's prompt.
   *
   * Use this method to:
   * - Enhance the agent's understanding of the user's request
   * - Refine the agent's response to be more accurate and relevant
   *
   * @generated from rpc gitpod.v1.AgentService.ImprovePromptForAgent
   */
  improvePromptForAgent: {
    methodKind: "unary";
    input: typeof ImprovePromptForAgentRequestSchema;
    output: typeof ImprovePromptForAgentResponseSchema;
  },
  /**
   * Creates a token for LLM access with a specific agent run.
   *
   *
   * @generated from rpc gitpod.v1.AgentService.CreateLLMAccessToken
   */
  createLLMAccessToken: {
    methodKind: "unary";
    input: typeof CreateLLMAccessTokenRequestSchema;
    output: typeof CreateLLMAccessTokenResponseSchema;
  },
  /**
   * Lists all MCP integrations.
   *
   * Use this method to retrieve all configured MCP integrations.
   *
   * ### Examples
   *
   * - List all MCP integrations:
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 10
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.ListMCPIntegrations
   */
  listMCPIntegrations: {
    methodKind: "unary";
    input: typeof ListMCPIntegrationsRequestSchema;
    output: typeof ListMCPIntegrationsResponseSchema;
  },
  /**
   * Creates a token for MCP access.
   *
   * Use this method to generate an access token for MCP integrations.
   *
   * @generated from rpc gitpod.v1.AgentService.CreateMCPAccessToken
   */
  createMCPAccessToken: {
    methodKind: "unary";
    input: typeof CreateMCPAccessTokenRequestSchema;
    output: typeof CreateMCPAccessTokenResponseSchema;
  },
  /**
   * Creates a token for search access.
   *
   * Use this method to generate an access token for search proxy integrations.
   *
   * @generated from rpc gitpod.v1.AgentService.CreateSearchAccessToken
   */
  createSearchAccessToken: {
    methodKind: "unary";
    input: typeof CreateSearchAccessTokenRequestSchema;
    output: typeof CreateSearchAccessTokenResponseSchema;
  },
  /**
   * Lists all prompts matching the specified criteria.
   *
   * Use this method to find and browse prompts across your organization.
   * Results are ordered by their creation time with the newest first.
   *
   * ### Examples
   *
   * - List all prompts:
   *
   *   Retrieves all prompts with pagination.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 10
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.ListPrompts
   */
  listPrompts: {
    methodKind: "unary";
    input: typeof ListPromptsRequestSchema;
    output: typeof ListPromptsResponseSchema;
  },
  /**
   * Gets details about a specific prompt including name, description,
   * and prompt content.
   *
   * Use this method to:
   * - Retrieve prompt details for editing
   * - Get prompt content for execution
   *
   * ### Examples
   *
   * - Get prompt details:
   *
   *   ```yaml
   *   promptId: "07e03a28-65a5-4d98-b532-8ea67b188048"
   *   ```
   *
   * @generated from rpc gitpod.v1.AgentService.GetPrompt
   */
  getPrompt: {
    methodKind: "unary";
    input: typeof GetPromptRequestSchema;
    output: typeof GetPromptResponseSchema;
  },
  /**
   * Creates a new prompt.
   *
   * Use this method to:
   * - Define new prompts for templates or commands
   * - Set up organization-wide prompt libraries
   *
   * @generated from rpc gitpod.v1.AgentService.CreatePrompt
   */
  createPrompt: {
    methodKind: "unary";
    input: typeof CreatePromptRequestSchema;
    output: typeof CreatePromptResponseSchema;
  },
  /**
   * Updates an existing prompt.
   *
   * Use this method to:
   * - Modify prompt content or metadata
   * - Change prompt type (template/command)
   *
   * @generated from rpc gitpod.v1.AgentService.UpdatePrompt
   */
  updatePrompt: {
    methodKind: "unary";
    input: typeof UpdatePromptRequestSchema;
    output: typeof UpdatePromptResponseSchema;
  },
  /**
   * Deletes a prompt.
   *
   * Use this method to:
   * - Remove unused prompts
   *
   * @generated from rpc gitpod.v1.AgentService.DeletePrompt
   */
  deletePrompt: {
    methodKind: "unary";
    input: typeof DeletePromptRequestSchema;
    output: typeof DeletePromptResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_agent, 0);

